"use client";
import { composeRenderProps as ae, Button as $e, DropZone as Nn, FileTrigger as ht, Label as Sn, Text as Bt, FieldError as Pn, Group as Mn, Input as Rn, Form as Ln, TextField as En, ListBox as Vt, ListBoxItem as Gt, Section as Tn, Header as zn, Collection as An, Menu as Fn, MenuItem as In, Popover as Ht, MenuTrigger as $n, Separator as jn, Modal as Wt, ModalOverlay as Dt, Dialog as Ut, DialogTrigger as qt, Radio as _n, RadioGroup as On, Select as Bn, SelectValue as Vn, Slider as Gn, SliderTrack as Hn, SliderThumb as Wn, Switch as Dn, Tab as Un, TabList as qn, TabPanel as Kn, Tabs as Zn } from "react-aria-components";
import * as _ from "react";
import at, { useState as Q, useRef as se, useCallback as ye, useSyncExternalStore as Xn, forwardRef as je, useEffect as Ae, useLayoutEffect as Kt, useMemo as me, createContext as lt, useContext as ct, useImperativeHandle as Zt, memo as Yn } from "react";
import { jsx as l, jsxs as O, Fragment as pe } from "react/jsx-runtime";
import { motion as ne, AnimatePresence as Jn } from "framer-motion";
import { NavLink as dt } from "react-router-dom";
import { FormattedMessage as yt } from "react-intl";
import { toast as vt } from "sonner";
function Xt(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = Xt(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Qn() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = Xt(e)) && (r && (r += " "), r += t);
  return r;
}
const ut = "-", er = (e) => {
  const t = nr(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (s) => {
      const a = s.split(ut);
      return a[0] === "" && a.length !== 1 && a.shift(), Yt(a, t) || tr(s);
    },
    getConflictingClassGroupIds: (s, a) => {
      const c = n[s] || [];
      return a && r[s] ? [...c, ...r[s]] : c;
    }
  };
}, Yt = (e, t) => {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), i = r ? Yt(e.slice(1), r) : void 0;
  if (i)
    return i;
  if (t.validators.length === 0)
    return;
  const o = e.join(ut);
  return (s = t.validators.find(({
    validator: a
  }) => a(o))) == null ? void 0 : s.classGroupId;
}, xt = /^\[(.+)\]$/, tr = (e) => {
  if (xt.test(e)) {
    const t = xt.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, nr = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return or(Object.entries(e.classGroups), n).forEach(([o, s]) => {
    Je(s, r, o, t);
  }), r;
}, Je = (e, t, n, r) => {
  e.forEach((i) => {
    if (typeof i == "string") {
      const o = i === "" ? t : wt(t, i);
      o.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (rr(i)) {
        Je(i(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(([o, s]) => {
      Je(s, wt(t, o), n, r);
    });
  });
}, wt = (e, t) => {
  let n = e;
  return t.split(ut).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, rr = (e) => e.isThemeGetter, or = (e, t) => t ? e.map(([n, r]) => {
  const i = r.map((o) => typeof o == "string" ? t + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([s, a]) => [t + s, a])) : o);
  return [n, i];
}) : e, ir = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const i = (o, s) => {
    n.set(o, s), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(o) {
      let s = n.get(o);
      if (s !== void 0)
        return s;
      if ((s = r.get(o)) !== void 0)
        return i(o, s), s;
    },
    set(o, s) {
      n.has(o) ? n.set(o, s) : i(o, s);
    }
  };
}, Jt = "!", sr = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, i = t[0], o = t.length, s = (a) => {
    const c = [];
    let u = 0, d = 0, g;
    for (let h = 0; h < a.length; h++) {
      let w = a[h];
      if (u === 0) {
        if (w === i && (r || a.slice(h, h + o) === t)) {
          c.push(a.slice(d, h)), d = h + o;
          continue;
        }
        if (w === "/") {
          g = h;
          continue;
        }
      }
      w === "[" ? u++ : w === "]" && u--;
    }
    const f = c.length === 0 ? a : a.substring(d), b = f.startsWith(Jt), R = b ? f.substring(1) : f, y = g && g > d ? g - d : void 0;
    return {
      modifiers: c,
      hasImportantModifier: b,
      baseClassName: R,
      maybePostfixModifierPosition: y
    };
  };
  return n ? (a) => n({
    className: a,
    parseClassName: s
  }) : s;
}, ar = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, lr = (e) => ({
  cache: ir(e.cacheSize),
  parseClassName: sr(e),
  ...er(e)
}), cr = /\s+/, dr = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: i
  } = t, o = [], s = e.trim().split(cr);
  let a = "";
  for (let c = s.length - 1; c >= 0; c -= 1) {
    const u = s[c], {
      modifiers: d,
      hasImportantModifier: g,
      baseClassName: f,
      maybePostfixModifierPosition: b
    } = n(u);
    let R = !!b, y = r(R ? f.substring(0, b) : f);
    if (!y) {
      if (!R) {
        a = u + (a.length > 0 ? " " + a : a);
        continue;
      }
      if (y = r(f), !y) {
        a = u + (a.length > 0 ? " " + a : a);
        continue;
      }
      R = !1;
    }
    const h = ar(d).join(":"), w = g ? h + Jt : h, k = w + y;
    if (o.includes(k))
      continue;
    o.push(k);
    const N = i(y, R);
    for (let T = 0; T < N.length; ++T) {
      const I = N[T];
      o.push(w + I);
    }
    a = u + (a.length > 0 ? " " + a : a);
  }
  return a;
};
function ur() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = Qt(t)) && (r && (r += " "), r += n);
  return r;
}
const Qt = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = Qt(e[r])) && (n && (n += " "), n += t);
  return n;
};
function Qe(e, ...t) {
  let n, r, i, o = s;
  function s(c) {
    const u = t.reduce((d, g) => g(d), e());
    return n = lr(u), r = n.cache.get, i = n.cache.set, o = a, a(c);
  }
  function a(c) {
    const u = r(c);
    if (u)
      return u;
    const d = dr(c, n);
    return i(c, d), d;
  }
  return function() {
    return o(ur.apply(null, arguments));
  };
}
const G = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, en = /^\[(?:([a-z-]+):)?(.+)\]$/i, fr = /^\d+\/\d+$/, gr = /* @__PURE__ */ new Set(["px", "full", "screen"]), mr = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, br = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, pr = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, hr = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, yr = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, ce = (e) => xe(e) || gr.has(e) || fr.test(e), ue = (e) => Ce(e, "length", Pr), xe = (e) => !!e && !Number.isNaN(Number(e)), Ke = (e) => Ce(e, "number", xe), Se = (e) => !!e && Number.isInteger(Number(e)), vr = (e) => e.endsWith("%") && xe(e.slice(0, -1)), S = (e) => en.test(e), fe = (e) => mr.test(e), xr = /* @__PURE__ */ new Set(["length", "size", "percentage"]), wr = (e) => Ce(e, xr, tn), Cr = (e) => Ce(e, "position", tn), kr = /* @__PURE__ */ new Set(["image", "url"]), Nr = (e) => Ce(e, kr, Rr), Sr = (e) => Ce(e, "", Mr), Pe = () => !0, Ce = (e, t, n) => {
  const r = en.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, Pr = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  br.test(e) && !pr.test(e)
), tn = () => !1, Mr = (e) => hr.test(e), Rr = (e) => yr.test(e), et = () => {
  const e = G("colors"), t = G("spacing"), n = G("blur"), r = G("brightness"), i = G("borderColor"), o = G("borderRadius"), s = G("borderSpacing"), a = G("borderWidth"), c = G("contrast"), u = G("grayscale"), d = G("hueRotate"), g = G("invert"), f = G("gap"), b = G("gradientColorStops"), R = G("gradientColorStopPositions"), y = G("inset"), h = G("margin"), w = G("opacity"), k = G("padding"), N = G("saturate"), T = G("scale"), I = G("sepia"), $ = G("skew"), W = G("space"), Z = G("translate"), J = () => ["auto", "contain", "none"], v = () => ["auto", "hidden", "clip", "visible", "scroll"], A = () => ["auto", S, t], m = () => [S, t], x = () => ["", ce, ue], p = () => ["auto", xe, S], M = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], C = () => ["solid", "dashed", "dotted", "double", "none"], L = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], P = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], z = () => ["", "0", S], j = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], V = () => [xe, S];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Pe],
      spacing: [ce, ue],
      blur: ["none", "", fe, S],
      brightness: V(),
      borderColor: [e],
      borderRadius: ["none", "", "full", fe, S],
      borderSpacing: m(),
      borderWidth: x(),
      contrast: V(),
      grayscale: z(),
      hueRotate: V(),
      invert: z(),
      gap: m(),
      gradientColorStops: [e],
      gradientColorStopPositions: [vr, ue],
      inset: A(),
      margin: A(),
      opacity: V(),
      padding: m(),
      saturate: V(),
      scale: V(),
      sepia: z(),
      skew: V(),
      space: m(),
      translate: m()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", S]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [fe]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": j()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": j()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...M(), S]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: v()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": v()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": v()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: J()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": J()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": J()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [y]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [y]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [y]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [y]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [y]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [y]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [y]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [y]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [y]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Se, S]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: A()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", S]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: z()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: z()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Se, S]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Pe]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Se, S]
        }, S]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": p()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": p()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Pe]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Se, S]
        }, S]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": p()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": p()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", S]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", S]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...P()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...P(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...P(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [k]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [k]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [k]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [k]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [k]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [k]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [k]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [k]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [k]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [h]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [h]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [h]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [h]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [h]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [h]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [h]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [h]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [h]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [W]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [W]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", S, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [S, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [S, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [fe]
        }, fe]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [S, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [S, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [S, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [S, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", fe, ue]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Ke]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Pe]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", S]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", xe, Ke]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", ce, S]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", S]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", S]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [w]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [w]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...C(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", ce, ue]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", ce, S]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: m()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", S]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", S]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [w]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...M(), Cr]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", wr]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Nr]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [R]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [R]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [R]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [b]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [b]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [b]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [w]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...C(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [w]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: C()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [i]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...C()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [ce, S]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [ce, ue]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: x()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [w]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [ce, ue]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", fe, Sr]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Pe]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [w]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...L(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": L()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", fe, S]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [g]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [N]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [I]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [g]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [w]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [N]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [I]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", S]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: V()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", S]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: V()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", S]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [T]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [T]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [T]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Se, S]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [Z]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [Z]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [$]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [$]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", S]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", S]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": m()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": m()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": m()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": m()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": m()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": m()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": m()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": m()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": m()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": m()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": m()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": m()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": m()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": m()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": m()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": m()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": m()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": m()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", S]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [ce, ue, Ke]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, Lr = (e, {
  cacheSize: t,
  prefix: n,
  separator: r,
  experimentalParseClassName: i,
  extend: o = {},
  override: s = {}
}) => {
  Re(e, "cacheSize", t), Re(e, "prefix", n), Re(e, "separator", r), Re(e, "experimentalParseClassName", i);
  for (const a in s)
    Er(e[a], s[a]);
  for (const a in o)
    Tr(e[a], o[a]);
  return e;
}, Re = (e, t, n) => {
  n !== void 0 && (e[t] = n);
}, Er = (e, t) => {
  if (t)
    for (const n in t)
      Re(e, n, t[n]);
}, Tr = (e, t) => {
  if (t)
    for (const n in t) {
      const r = t[n];
      r !== void 0 && (e[n] = (e[n] || []).concat(r));
    }
}, zr = (e, ...t) => typeof e == "function" ? Qe(et, e, ...t) : Qe(() => Lr(et(), e), ...t), nn = /* @__PURE__ */ Qe(et);
function B(...e) {
  return nn(Qn(e));
}
function ke(e, t) {
  return ae(e, (n) => B(t, n));
}
function ji() {
  const [e, t] = Q(!1), n = se(null), r = ye(() => {
    t(!0);
  }, []), i = ye(() => {
    t(!1);
  }, []);
  return [ye(
    (s) => {
      var a;
      ((a = n.current) == null ? void 0 : a.nodeType) === Node.ELEMENT_NODE && (n.current.removeEventListener(
        "mouseenter",
        r
      ), n.current.removeEventListener(
        "mouseleave",
        i
      )), (s == null ? void 0 : s.nodeType) === Node.ELEMENT_NODE && (s.addEventListener("mouseenter", r), s.addEventListener("mouseleave", i)), n.current = s;
    },
    [r, i]
  ), e];
}
function _i() {
  const [e, t] = Q({
    width: null,
    height: null
  }), n = se(null);
  return [ye((i) => {
    if (n.current && (n.current.disconnect(), n.current = null), (i == null ? void 0 : i.nodeType) === Node.ELEMENT_NODE) {
      const o = new ResizeObserver(([s]) => {
        if (s != null && s.borderBoxSize) {
          const { inlineSize: a, blockSize: c } = s.borderBoxSize[0];
          t({ width: a, height: c });
        }
      });
      o.observe(i), n.current = o;
    }
  }, []), e];
}
const Ar = {
  theme: {
    screens: {
      sm: "640px",
      md: "1024px",
      lg: "1280px"
    }
  }
};
function rn(e) {
  const n = `only screen and (max-width : ${Ar.theme.screens[e]})`, r = ye(
    (s) => {
      if (typeof window > "u")
        return () => null;
      const a = window.matchMedia(n);
      return a.addEventListener("change", s), () => a.removeEventListener("change", s);
    },
    [n]
  );
  return Xn(r, () => typeof window > "u" ? null : window.matchMedia(n).matches, () => null);
}
const Fr = at.createContext("");
function Ir() {
  return at.useContext(Fr);
}
function ie({
  icon: e,
  className: t,
  size: n = "md",
  dynamicColor: r = !0,
  ...i
}) {
  const o = n === "sm", s = Ir();
  return r ? /* @__PURE__ */ l(
    "span",
    {
      className: B(
        o ? "size-4" : "size-6",
        "bg-black inline-block",
        t
      ),
      style: {
        maskImage: `url(${s}/icons/${e}${o ? "_sm" : ""}.svg)`,
        maskSize: "100%",
        maskRepeat: "no-repeat",
        maskPosition: "center"
      },
      ...i
    }
  ) : /* @__PURE__ */ l(
    "img",
    {
      className: B(o ? "size-4" : "size-6", t),
      src: `${s}/icons/${e}${o ? "_sm" : ""}.svg`,
      style: { background: "transparent" },
      ...i
    }
  );
}
function Oi({
  icon: e,
  className: t,
  ...n
}) {
  return /* @__PURE__ */ l(
    $e,
    {
      ...n,
      className: B(
        "w-20 h-12 flex items-center bg-grey-2 justify-center rounded-9",
        t
      ),
      children: /* @__PURE__ */ l(ie, { icon: e, className: "bg-black size-6", size: "sm" })
    }
  );
}
var Ct = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, te = (e) => !e || typeof e != "object" || Object.keys(e).length === 0, $r = (e, t) => JSON.stringify(e) === JSON.stringify(t);
function on(e, t) {
  e.forEach(function(n) {
    Array.isArray(n) ? on(n, t) : t.push(n);
  });
}
function sn(e) {
  let t = [];
  return on(e, t), t;
}
var an = (...e) => sn(e).filter(Boolean), ln = (e, t) => {
  let n = {}, r = Object.keys(e), i = Object.keys(t);
  for (let o of r) if (i.includes(o)) {
    let s = e[o], a = t[o];
    typeof s == "object" && typeof a == "object" ? n[o] = ln(s, a) : Array.isArray(s) || Array.isArray(a) ? n[o] = an(a, s) : n[o] = a + " " + s;
  } else n[o] = e[o];
  for (let o of i) r.includes(o) || (n[o] = t[o]);
  return n;
}, kt = (e) => !e || typeof e != "string" ? e : e.replace(/\s+/g, " ").trim(), jr = { twMerge: !0, twMergeConfig: {}, responsiveVariants: !1 }, cn = (e) => e || void 0, Fe = (...e) => cn(sn(e).filter(Boolean).join(" ")), Ze = null, de = {}, tt = !1, Me = (...e) => (t) => t.twMerge ? ((!Ze || tt) && (tt = !1, Ze = te(de) ? nn : zr({ ...de, extend: { theme: de.theme, classGroups: de.classGroups, conflictingClassGroupModifiers: de.conflictingClassGroupModifiers, conflictingClassGroups: de.conflictingClassGroups, ...de.extend } })), cn(Ze(Fe(e)))) : Fe(e), Nt = (e, t) => {
  for (let n in t) e.hasOwnProperty(n) ? e[n] = Fe(e[n], t[n]) : e[n] = t[n];
  return e;
}, re = (e, t) => {
  let { extend: n = null, slots: r = {}, variants: i = {}, compoundVariants: o = [], compoundSlots: s = [], defaultVariants: a = {} } = e, c = { ...jr, ...t }, u = n != null && n.base ? Fe(n.base, e == null ? void 0 : e.base) : e == null ? void 0 : e.base, d = n != null && n.variants && !te(n.variants) ? ln(i, n.variants) : i, g = n != null && n.defaultVariants && !te(n.defaultVariants) ? { ...n.defaultVariants, ...a } : a;
  !te(c.twMergeConfig) && !$r(c.twMergeConfig, de) && (tt = !0, de = c.twMergeConfig);
  let f = te(n == null ? void 0 : n.slots), b = te(r) ? {} : { base: Fe(e == null ? void 0 : e.base, f && (n == null ? void 0 : n.base)), ...r }, R = f ? b : Nt({ ...n == null ? void 0 : n.slots }, te(b) ? { base: e == null ? void 0 : e.base } : b), y = te(n == null ? void 0 : n.compoundVariants) ? o : an(n == null ? void 0 : n.compoundVariants, o), h = (k) => {
    if (te(d) && te(r) && f) return Me(u, k == null ? void 0 : k.class, k == null ? void 0 : k.className)(c);
    if (y && !Array.isArray(y)) throw new TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof y}`);
    if (s && !Array.isArray(s)) throw new TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof s}`);
    let N = (m, x, p = [], M) => {
      let C = p;
      if (typeof x == "string") C = C.concat(kt(x).split(" ").map((L) => `${m}:${L}`));
      else if (Array.isArray(x)) C = C.concat(x.reduce((L, P) => L.concat(`${m}:${P}`), []));
      else if (typeof x == "object" && typeof M == "string") {
        for (let L in x) if (x.hasOwnProperty(L) && L === M) {
          let P = x[L];
          if (P && typeof P == "string") {
            let z = kt(P);
            C[M] ? C[M] = C[M].concat(z.split(" ").map((j) => `${m}:${j}`)) : C[M] = z.split(" ").map((j) => `${m}:${j}`);
          } else Array.isArray(P) && P.length > 0 && (C[M] = P.reduce((z, j) => z.concat(`${m}:${j}`), []));
        }
      }
      return C;
    }, T = (m, x = d, p = null, M = null) => {
      var C;
      let L = x[m];
      if (!L || te(L)) return null;
      let P = (C = M == null ? void 0 : M[m]) != null ? C : k == null ? void 0 : k[m];
      if (P === null) return null;
      let z = Ct(P), j = Array.isArray(c.responsiveVariants) && c.responsiveVariants.length > 0 || c.responsiveVariants === !0, V = g == null ? void 0 : g[m], D = [];
      if (typeof z == "object" && j) for (let [X, le] of Object.entries(z)) {
        let E = L[le];
        if (X === "initial") {
          V = le;
          continue;
        }
        Array.isArray(c.responsiveVariants) && !c.responsiveVariants.includes(X) || (D = N(X, E, D, p));
      }
      let he = z != null && typeof z != "object" ? z : Ct(V), U = L[he || "false"];
      return typeof D == "object" && typeof p == "string" && D[p] ? Nt(D, U) : D.length > 0 ? (D.push(U), D) : U;
    }, I = () => d ? Object.keys(d).map((m) => T(m, d)) : null, $ = (m, x) => {
      if (!d || typeof d != "object") return null;
      let p = new Array();
      for (let M in d) {
        let C = T(M, d, m, x), L = m === "base" && typeof C == "string" ? C : C && C[m];
        L && (p[p.length] = L);
      }
      return p;
    }, W = {};
    for (let m in k) k[m] !== void 0 && (W[m] = k[m]);
    let Z = (m, x) => {
      var p;
      let M = typeof (k == null ? void 0 : k[m]) == "object" ? { [m]: (p = k[m]) == null ? void 0 : p.initial } : {};
      return { ...g, ...W, ...M, ...x };
    }, J = (m = [], x) => {
      let p = [];
      for (let { class: M, className: C, ...L } of m) {
        let P = !0;
        for (let [z, j] of Object.entries(L)) {
          let V = Z(z, x);
          if (Array.isArray(j)) {
            if (!j.includes(V[z])) {
              P = !1;
              break;
            }
          } else if (V[z] !== j) {
            P = !1;
            break;
          }
        }
        P && (M && p.push(M), C && p.push(C));
      }
      return p;
    }, v = (m) => {
      let x = J(y, m);
      if (!Array.isArray(x)) return x;
      let p = {};
      for (let M of x) if (typeof M == "string" && (p.base = Me(p.base, M)(c)), typeof M == "object") for (let [C, L] of Object.entries(M)) p[C] = Me(p[C], L)(c);
      return p;
    }, A = (m) => {
      if (s.length < 1) return null;
      let x = {};
      for (let { slots: p = [], class: M, className: C, ...L } of s) {
        if (!te(L)) {
          let P = !0;
          for (let z of Object.keys(L)) {
            let j = Z(z, m)[z];
            if (j === void 0 || (Array.isArray(L[z]) ? !L[z].includes(j) : L[z] !== j)) {
              P = !1;
              break;
            }
          }
          if (!P) continue;
        }
        for (let P of p) x[P] = x[P] || [], x[P].push([M, C]);
      }
      return x;
    };
    if (!te(r) || !f) {
      let m = {};
      if (typeof R == "object" && !te(R)) for (let x of Object.keys(R)) m[x] = (p) => {
        var M, C;
        return Me(R[x], $(x, p), ((M = v(p)) != null ? M : [])[x], ((C = A(p)) != null ? C : [])[x], p == null ? void 0 : p.class, p == null ? void 0 : p.className)(c);
      };
      return m;
    }
    return Me(u, I(), J(y), k == null ? void 0 : k.class, k == null ? void 0 : k.className)(c);
  }, w = () => {
    if (!(!d || typeof d != "object")) return Object.keys(d);
  };
  return h.variantKeys = w(), h.extend = n, h.base = u, h.slots = R, h.variants = d, h.defaultVariants = g, h.compoundSlots = s, h.compoundVariants = y, h;
};
const _r = re({
  base: "box-border shrink-0 font-semibold text-2xs flex justify-center items-center uppercase",
  variants: {
    color: {
      primary: "bg-peach",
      white: "bg-white text-black border-2 border-grey-2",
      grey: "text-white bg-grey-10 border-2 border-grey-8"
    },
    variant: {
      square: "px-2 rounded-2 h-6",
      round: "size-6 rounded-full"
    }
  }
});
function Bi({
  children: e,
  color: t = "primary",
  variant: n = "square",
  className: r,
  style: i
}) {
  return /* @__PURE__ */ l("div", { className: _r({ color: t, variant: n, className: r }), style: i, children: e });
}
const ft = "flex px-4 rounded-4 items-center w-66 outline-none bg-white hover:bg-grey-2 focus:bg-grey-2 leading-8 transition-colors my-1 cursor-pointer", Or = re({
  base: ft,
  variants: {
    size: {
      base: "h-12",
      lg: "h-16"
    }
  },
  defaultVariants: {
    size: "base"
  }
}), Br = ne($e), Vr = re({
  slots: {
    base: "",
    text: "",
    icon: "size-[14px]"
  },
  variants: {
    variant: {
      menu: {
        base: ft
      },
      default: {
        base: "group font-medium outline-none leading-6 rounded-8 transition-colors flex items-center justify-center text-black"
      },
      square: {
        base: "group font-medium outline-none leading-6 rounded-2 transition-colors flex items-center justify-center text-black"
      }
    },
    size: {
      xs: "text-sm h-6 p-4",
      s: "text-sm h-10 px-7",
      m: "text-sm h-12 px-7",
      l: "text-base h-14 px-8",
      xl: "text-base h-16 px-11"
    },
    color: {
      gradient: {
        base: "scale-100 border-2 border-peach text-white hover:scale-105 disabled:scale-100 transition-transform disabled:text-nude",
        icon: "bg-white group-disabled:bg-nude",
        text: "drop-shadow"
      },
      tangerine: {},
      grey: {
        base: "bg-grey-2 hover:bg-grey-3 active:bg-grey-3 active:border-grey-5 focus:bg-grey-3 focus:border-grey-5 disabled:bg-grey-2 disabled:text-grey-6",
        icon: "bg-black group-disabled:bg-grey-6"
      },
      "dark-grey": {
        base: "text-white bg-grey-9 hover:bg-grey-10 active:bg-grey-10 active:border-black active:border-2 focus:border-black focus:bg-grey-10 focus:border-2 disabled:bg-black disabled:text-grey-7 border-1 border-white",
        icon: "bg-white group-disabled:bg-grey-7"
      },
      black: {},
      red: {},
      green: {},
      blue: {}
    }
  },
  compoundVariants: [
    {
      variant: "default",
      color: "tangerine",
      className: {
        base: "bg-peach hover:bg-tangerine active:bg-peach active:border-tangerine  focus:border-tangerine disabled:bg-nude disabled:text-grey-8",
        icon: "bg-black group-disabled:bg-grey-8"
      }
    },
    {
      variant: "default",
      color: "green",
      className: {
        base: "bg-green-secondary hover:bg-green active:bg-green active:border-green focus:border-green disabled:bg-nude disabled:text-grey-8",
        icon: "bg-black group-disabled:bg-grey-8"
      }
    },
    {
      variant: "default",
      color: "blue",
      className: {
        base: "bg-blue hover:bg-blue-2 active:bg-blue active:border-blue focus:border-blue disabled:bg-nude disabled:text-grey-8",
        icon: "bg-black group-disabled:bg-grey-8"
      }
    },
    {
      variant: "default",
      color: "black",
      className: {
        base: "text-white bg-black hover:bg-grey-10 active:bg-grey-10 active:border-black active:border-2 focus:border-black focus:bg-grey-10 focus:border-2 disabled:bg-black disabled:text-grey-7 border-1 border-white",
        icon: "bg-white group-disabled:bg-grey-7"
      }
    },
    {
      variant: "default",
      color: "red",
      className: {
        base: "text-white bg-red disabled:text-grey-9",
        icon: "bg-white group-disabled:bg-grey-9"
      }
    }
  ],
  defaultVariants: {
    size: "s",
    color: "tangerine",
    variant: "default"
  }
}), Gr = je(
  ({
    size: e = "s",
    color: t = "tangerine",
    children: n,
    leftIcon: r,
    rightIcon: i,
    variant: o = "default",
    iconDynamicColor: s = !0,
    href: a,
    ...c
  }, u) => {
    const { base: d, icon: g, text: f } = Vr({ variant: o }), b = g({ size: e, color: t }), R = f({ size: e, color: t }), y = /* @__PURE__ */ O(pe, { children: [
      r && /* @__PURE__ */ l(
        ie,
        {
          className: B(b, "mr-2"),
          size: "sm",
          icon: r,
          dynamicColor: s
        }
      ),
      /* @__PURE__ */ l("span", { className: B(R, "flex items-center"), children: n }),
      i && /* @__PURE__ */ l(
        ie,
        {
          className: B(b, "ml-2"),
          size: "sm",
          icon: i,
          dynamicColor: s
        }
      )
    ] });
    if (a)
      return (
        // @ts-ignore
        /* @__PURE__ */ l(
          dt,
          {
            to: a,
            ...c,
            className: d({
              size: e,
              color: t,
              className: c.className
            }),
            children: y
          }
        )
      );
    let h = {};
    return t === "gradient" && (h = {
      initial: { backgroundPosition: "0 0" },
      animate: { backgroundPositionX: ["0px", "600px"] },
      transition: {
        duration: 3,
        delay: Math.random() * 2,
        ease: "linear",
        repeat: 1 / 0,
        repeatType: "loop"
      },
      style: {
        backgroundImage: "linear-gradient(to right, #FFB861, #FF8670, #FF7FAF, #FF8670, #FFB861)",
        backgroundSize: "600px 100%",
        ...c.style
      }
    }), /* @__PURE__ */ l(
      Br,
      {
        ref: u,
        ...c,
        ...h,
        className: ae(
          c.className,
          (w, k) => d({
            ...k,
            size: e,
            color: t,
            className: w
          })
        ),
        children: y
      }
    );
  }
);
Gr.displayName = "Button";
function Vi(e) {
  const [t, n] = Q(!1);
  return /* @__PURE__ */ O(
    Nn,
    {
      ...e,
      onHoverStart: () => n(!0),
      onHoverEnd: () => n(!1),
      className: ({ isDropTarget: r }) => B(
        "group h-full w-full rounded-7 p-4",
        r && "border-3 border-blue bg-blue-light-1"
      ),
      children: [
        /* @__PURE__ */ O(
          "svg",
          {
            className: "absolute top-0 left-0 overflow-visible w-full h-full p-5 pointer-events-none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
              /* @__PURE__ */ O("linearGradient", { id: "linear", x1: "0%", y1: "100%", x2: "100%", y2: "0%", children: [
                /* @__PURE__ */ l("stop", { offset: "0%", stopColor: "#FFD745" }),
                /* @__PURE__ */ l("stop", { offset: "50%", stopColor: "#0097FF" }),
                /* @__PURE__ */ l("stop", { offset: "100%", stopColor: "#FF39C6" })
              ] }),
              /* @__PURE__ */ l(
                ne.rect,
                {
                  className: "group-hover:stroke-[url(#linear)] stroke-grey-4",
                  width: "100%",
                  height: "100%",
                  fill: "none",
                  rx: "24",
                  ry: "24",
                  strokeWidth: "2",
                  strokeDasharray: "10",
                  animate: { strokeDashoffset: t ? [0, 100] : [0] },
                  transition: {
                    repeat: 1 / 0,
                    duration: 4,
                    ease: "linear"
                  },
                  strokeLinecap: "square"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ l("div", { className: "w-full h-full p-5 md:p-10", children: e.children })
      ]
    }
  );
}
function St({
  label: e,
  ...t
}) {
  return e ? /* @__PURE__ */ O("label", { children: [
    /* @__PURE__ */ l("span", { className: "hidden", children: e }),
    /* @__PURE__ */ l(ht, { ...t })
  ] }) : /* @__PURE__ */ l(ht, { ...t });
}
const gt = re({
  base: "border-2 bg-white rounded-3 border-grey-10 text-black outline-none flex items-center min-w-0",
  variants: {
    size: {
      l: "h-14",
      sm: "h-8"
    },
    hasLeftIcon: {
      true: "pl-12 pr-4",
      false: "px-4"
    },
    isFocused: {
      true: "border-black"
    },
    isInvalid: {
      true: "border-red"
    },
    isDisabled: {
      true: "border-grey-4"
    }
  },
  defaultVariants: {
    size: "l"
  }
}), Hr = re({
  base: "group flex items-center h-9 bg-white border-2 rounded-lg overflow-hidden",
  variants: gt.variants
});
function mt(e) {
  return /* @__PURE__ */ l(
    Sn,
    {
      ...e,
      className: B(
        "font-medium text-md leading-7 text-grey-9 pl-4 mb-2 cursor-default w-fit",
        e.className
      )
    }
  );
}
function dn(e) {
  return /* @__PURE__ */ l(
    Bt,
    {
      ...e,
      slot: "description",
      className: B("text-sm text-gray-600", e.className)
    }
  );
}
function un(e) {
  return /* @__PURE__ */ l(
    Pn,
    {
      ...e,
      className: ke(
        e.className,
        "text-sm text-red"
      )
    }
  );
}
function Gi(e) {
  return /* @__PURE__ */ l(
    Mn,
    {
      ...e,
      className: ae(
        e.className,
        (t, n) => Hr({ ...n, className: t })
      )
    }
  );
}
function Wr({
  leftIcon: e,
  rightElement: t,
  size: n = "l",
  ...r
}) {
  return /* @__PURE__ */ O("div", { className: "relative", children: [
    /* @__PURE__ */ l(
      Rn,
      {
        ...r,
        className: ke(
          (i) => gt({ hasLeftIcon: !!e, size: n, ...i }),
          "w-full"
        )
      }
    ),
    e && /* @__PURE__ */ l(
      "span",
      {
        "aria-hidden": "true",
        className: "pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 flex",
        children: /* @__PURE__ */ l(ie, { icon: e, className: "size-5" })
      }
    ),
    t && /* @__PURE__ */ l("span", { className: "absolute right-4 top-1/2 -translate-y-1/2 flex", children: t })
  ] });
}
function Hi(e) {
  return /* @__PURE__ */ l(
    Ln,
    {
      ...e,
      className: B("flex flex-col gap-4", e.className)
    }
  );
}
function Wi({
  leftIcon: e,
  label: t,
  description: n,
  errorMessage: r,
  placeholder: i,
  rightElement: o,
  size: s,
  ...a
}) {
  return /* @__PURE__ */ O(
    En,
    {
      ...a,
      className: ke(
        a.className,
        "flex flex-col gap-1"
      ),
      children: [
        t && /* @__PURE__ */ l(mt, { children: t }),
        /* @__PURE__ */ l(
          Wr,
          {
            placeholder: i,
            leftIcon: e,
            rightElement: o,
            size: s
          }
        ),
        n && /* @__PURE__ */ l(dn, { children: n }),
        /* @__PURE__ */ l(un, { children: r })
      ]
    }
  );
}
const Dr = re({
  slots: {
    base: "group flex items-center justify-center outline-none",
    icon: "size-4 transition-all"
  },
  variants: {
    variant: {
      square: "size-6 rounded-2",
      round: {
        base: "size-8 transition-all rounded-full",
        icon: "group-hover:size-5"
      }
    },
    color: {
      transparent: {
        base: "transparent",
        icon: "bg-black"
      },
      dark: {
        base: "bg-black/70",
        icon: "bg-white"
      },
      tangerine: {
        base: "bg-peach",
        icon: "bg-black"
      },
      grey: {
        base: "bg-grey-2",
        icon: "bg-black"
      },
      black: {
        base: "bg-black",
        icon: "bg-white"
      }
    }
  },
  defaultVariants: {
    color: "tangerine"
  }
});
function fn({
  color: e,
  icon: t,
  variant: n = "round",
  iconDynamicColor: r = !0,
  iconClassName: i,
  ...o
}) {
  const { base: s, icon: a } = Dr({ color: e, variant: n });
  return /* @__PURE__ */ l(
    $e,
    {
      ...o,
      className: ae(
        o.className,
        (c, u) => s({ ...u, className: c })
      ),
      children: /* @__PURE__ */ l(
        ie,
        {
          className: a({ className: i }),
          icon: t,
          size: "md",
          dynamicColor: r
        }
      )
    }
  );
}
const Pt = re({
  base: "outline-none hover:underline transition font-medium tracking-normal text-black",
  variants: {
    variant: {
      "link-1": "text-base leading-12",
      "link-2": "text-md leading-11",
      "link-3": "text-sm leading-10",
      "link-4": "text-xs leading-9",
      "link-5": "text-2xs leading-8"
    }
  },
  defaultVariants: {
    variant: "link-1"
  }
}), nt = je(
  ({ variant: e = "link-1", className: t, href: n, ...r }, i) => n ? /* @__PURE__ */ l(
    dt,
    {
      ...r,
      to: n,
      ref: i,
      className: Pt({ variant: e, className: t })
    }
  ) : /* @__PURE__ */ l(
    $e,
    {
      onPress: r.onPress,
      className: Pt({ variant: e, className: t }),
      children: r.children
    }
  )
);
nt.displayName = "Link";
function Ur({
  className: e,
  isTeam: t,
  src: n,
  ...r
}) {
  const [i, o] = Q(!!n), s = B("rounded-full size-28 object-cover", e);
  return Ae(() => {
    o(!!n);
  }, [n]), t && !i ? /* @__PURE__ */ l(qr, { className: s }) : i ? /* @__PURE__ */ l(
    "img",
    {
      className: s,
      ...r,
      src: n ?? void 0,
      onError: () => o(!1)
    }
  ) : /* @__PURE__ */ l(Kr, { className: s });
}
function qr(e) {
  return /* @__PURE__ */ O("svg", { className: e.className, viewBox: "0 0 112 112", fill: "none", children: [
    /* @__PURE__ */ l("rect", { width: "112", height: "112", rx: "56", fill: "#C5C5C5" }),
    /* @__PURE__ */ l(
      "path",
      {
        d: "M48.4724 33C42.7661 33 38.2119 37.7091 38.2119 43.4288C38.2119 49.1484 42.7661 53.8575 48.4724 53.8575C54.1787 53.8575 58.7328 49.1484 58.7328 43.4288C58.7328 37.7091 54.1787 33 48.4724 33Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ l(
      "path",
      {
        d: "M63.5276 35.0955C62.3963 35.0955 61.4791 36.0124 61.4791 37.1435C61.4791 38.2745 62.3963 39.1914 63.5276 39.1914C65.7582 39.1914 67.6381 41.0487 67.6381 43.4291C67.6381 45.8095 65.7582 47.6668 63.5276 47.6668C62.3963 47.6668 61.4791 48.5837 61.4791 49.7147C61.4791 50.8458 62.3963 51.7627 63.5276 51.7627C68.1001 51.7627 71.7351 47.9916 71.7351 43.4291C71.7351 38.8666 68.1001 35.0955 63.5276 35.0955Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ l(
      "path",
      {
        d: "M41.2869 56.0473C35.0137 56.0473 30 61.2254 30 67.5236C30 73.8218 35.0137 79 41.2869 79H55.6578C61.931 79 66.9448 73.8218 66.9448 67.5236C66.9448 61.2254 61.9311 56.0473 55.6578 56.0473H41.2869Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ l(
      "path",
      {
        d: "M71.7396 58.1423C70.6082 58.1423 69.6911 59.0592 69.6911 60.1902C69.6911 61.3213 70.6082 62.2382 71.7396 62.2382H72.7661C75.5635 62.2382 77.903 64.5645 77.903 67.5235C77.903 70.4824 75.5635 72.8087 72.7661 72.8087H71.7396C70.6082 72.8087 69.6911 73.7256 69.6911 74.8567C69.6911 75.9877 70.6082 76.9046 71.7396 76.9046H72.7661C77.9054 76.9046 82 72.6645 82 67.5235C82 62.3824 77.9054 58.1423 72.7661 58.1423H71.7396Z",
        fill: "white"
      }
    )
  ] });
}
function Kr(e) {
  return /* @__PURE__ */ O("svg", { viewBox: "0 0 112 112", className: e.className, fill: "none", children: [
    /* @__PURE__ */ O("g", { clipPath: "url(#clip0_183_17928)", children: [
      /* @__PURE__ */ l("rect", { width: "112", height: "112", rx: "56", fill: "#D7D7D7" }),
      /* @__PURE__ */ l("rect", { width: "112", height: "112", rx: "56", fill: "#C5C5C5" }),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M56 30C49.2965 30 43.6759 35.2698 43.6759 41.9969C43.6759 48.7239 49.2965 53.9937 56 53.9937C62.7035 53.9937 68.3241 48.7239 68.3241 41.9969C68.3241 35.2698 62.7035 30 56 30Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M47.5336 55.6724C40.1621 55.6724 34 61.4647 34 68.8362C34 76.2077 40.1621 82 47.5336 82H64.4664C71.8379 82 78 76.2077 78 68.8362C78 61.4647 71.8379 55.6724 64.4664 55.6724H47.5336Z",
          fill: "white"
        }
      )
    ] }),
    /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_183_17928", children: /* @__PURE__ */ l("rect", { width: "112", height: "112", rx: "56", fill: "white" }) }) })
  ] });
}
function Di({
  src: e,
  isTeam: t = !1,
  isDisabled: n = !1,
  onChange: r,
  onDelete: i
}) {
  return /* @__PURE__ */ O("div", { className: "relative size-34 mb-4 group", "aria-label": "Image picker", children: [
    !n && /* @__PURE__ */ l("div", { className: "absolute w-full h-full rounded-full bg-black/50 opacity-0 group-hover:opacity-100 z-10 transition-all duration-200 flex flex-col justify-center items-center gap-3", children: e ? /* @__PURE__ */ O(pe, { children: [
      /* @__PURE__ */ l(
        St,
        {
          label: "replace picture",
          onSelect: r,
          acceptedFileTypes: ["image/*"],
          children: /* @__PURE__ */ l(nt, { variant: "link-4", className: "text-white", children: /* @__PURE__ */ l(yt, { id: "image_picker_replace" }) })
        }
      ),
      /* @__PURE__ */ l(ie, { icon: "photo", size: "sm", className: "bg-white" }),
      /* @__PURE__ */ l(nt, { onPress: i, variant: "link-4", className: "text-white", children: /* @__PURE__ */ l(yt, { id: "image_picker_remove" }) })
    ] }) : /* @__PURE__ */ l(
      St,
      {
        label: "add picture",
        acceptedFileTypes: ["image/*"],
        onSelect: r,
        children: /* @__PURE__ */ l(
          fn,
          {
            color: "transparent",
            iconClassName: "bg-white",
            icon: "plus"
          }
        )
      }
    ) }),
    /* @__PURE__ */ l(
      Ur,
      {
        className: "w-full h-full absolute",
        src: e,
        alt: "profile picture",
        isTeam: t
      }
    )
  ] });
}
const Y = 0, H = 1, Zr = 2, Xr = 0, rt = 1;
function Yr(e, t, n) {
  let r = e.list, i;
  for (; r; ) {
    if (r.index === n) return !1;
    if (t > r.high) break;
    i = r, r = r.next;
  }
  return i || (e.list = {
    index: n,
    high: t,
    next: r
  }), i && (i.next = {
    index: n,
    high: t,
    next: i.next
  }), !0;
}
function Jr(e, t) {
  let n = e.list;
  if (n.index === t)
    return n.next === null ? Xr : (e.list = n.next, rt);
  let r = n;
  for (n = n.next; n !== null; ) {
    if (n.index === t)
      return r.next = n.next, rt;
    r = n, n = n.next;
  }
}
const F = {
  low: 0,
  max: 0,
  high: 0,
  C: Zr,
  // @ts-expect-error
  P: void 0,
  // @ts-expect-error
  R: void 0,
  // @ts-expect-error
  L: void 0,
  // @ts-expect-error
  list: void 0
};
F.P = F;
F.L = F;
F.R = F;
function be(e) {
  const t = e.high;
  e.L === F && e.R === F ? e.max = t : e.L === F ? e.max = Math.max(e.R.max, t) : e.R === F ? e.max = Math.max(e.L.max, t) : e.max = Math.max(Math.max(e.L.max, e.R.max), t);
}
function _e(e) {
  let t = e;
  for (; t.P !== F; )
    be(t.P), t = t.P;
}
function Ee(e, t) {
  if (t.R === F) return;
  const n = t.R;
  t.R = n.L, n.L !== F && (n.L.P = t), n.P = t.P, t.P === F ? e.root = n : t === t.P.L ? t.P.L = n : t.P.R = n, n.L = t, t.P = n, be(t), be(n);
}
function Te(e, t) {
  if (t.L === F) return;
  const n = t.L;
  t.L = n.R, n.R !== F && (n.R.P = t), n.P = t.P, t.P === F ? e.root = n : t === t.P.R ? t.P.R = n : t.P.L = n, n.R = t, t.P = n, be(t), be(n);
}
function Oe(e, t, n) {
  t.P === F ? e.root = n : t === t.P.L ? t.P.L = n : t.P.R = n, n.P = t.P;
}
function Qr(e, t) {
  let n;
  for (; t !== F && t.C === H; )
    t === t.P.L ? (n = t.P.R, n.C === Y && (n.C = H, t.P.C = Y, Ee(e, t.P), n = t.P.R), n.L.C === H && n.R.C === H ? (n.C = Y, t = t.P) : (n.R.C === H && (n.L.C = H, n.C = Y, Te(e, n), n = t.P.R), n.C = t.P.C, t.P.C = H, n.R.C = H, Ee(e, t.P), t = e.root)) : (n = t.P.L, n.C === Y && (n.C = H, t.P.C = Y, Te(e, t.P), n = t.P.L), n.R.C === H && n.L.C === H ? (n.C = Y, t = t.P) : (n.L.C === H && (n.R.C = H, n.C = Y, Ee(e, n), n = t.P.L), n.C = t.P.C, t.P.C = H, n.L.C = H, Te(e, t.P), t = e.root));
  t.C = H;
}
function eo(e) {
  for (; e.L !== F; ) e = e.L;
  return e;
}
function to(e, t) {
  let n;
  for (; t.P.C === Y; )
    t.P === t.P.P.L ? (n = t.P.P.R, n.C === Y ? (t.P.C = H, n.C = H, t.P.P.C = Y, t = t.P.P) : (t === t.P.R && (t = t.P, Ee(e, t)), t.P.C = H, t.P.P.C = Y, Te(e, t.P.P))) : (n = t.P.P.L, n.C === Y ? (t.P.C = H, n.C = H, t.P.P.C = Y, t = t.P.P) : (t === t.P.L && (t = t.P, Te(e, t)), t.P.C = H, t.P.P.C = Y, Ee(e, t.P.P)));
  e.root.C = H;
}
function no() {
  const e = {
    root: F,
    size: 0
  }, t = {};
  return {
    insert(n, r, i) {
      let o = e.root, s = F;
      for (; o !== F && (s = o, n !== s.low); )
        n < o.low ? o = o.L : o = o.R;
      if (n === s.low && s !== F) {
        if (!Yr(s, r, i)) return;
        s.high = Math.max(s.high, r), be(s), _e(s), t[i] = s, e.size++;
        return;
      }
      const a = {
        low: n,
        high: r,
        max: r,
        C: Y,
        P: s,
        L: F,
        R: F,
        list: {
          index: i,
          high: r,
          next: null
        }
      };
      s === F ? e.root = a : (a.low < s.low ? s.L = a : s.R = a, _e(a)), to(e, a), t[i] = a, e.size++;
    },
    remove(n) {
      const r = t[n];
      if (r === void 0) return;
      delete t[n];
      const i = Jr(r, n);
      if (i === void 0) return;
      if (i === rt) {
        r.high = r.list.high, be(r), _e(r), e.size--;
        return;
      }
      let o = r, s = o.C, a;
      r.L === F ? (a = r.R, Oe(e, r, r.R)) : r.R === F ? (a = r.L, Oe(e, r, r.L)) : (o = eo(r.R), s = o.C, a = o.R, o.P === r ? a.P = o : (Oe(e, o, o.R), o.R = r.R, o.R.P = o), Oe(e, r, o), o.L = r.L, o.L.P = o, o.C = r.C), be(a), _e(a), s === H && Qr(e, a), e.size--;
    },
    search(n, r, i) {
      const o = [e.root];
      for (; o.length !== 0; ) {
        const s = o.pop();
        if (!(s === F || n > s.max) && (s.L !== F && o.push(s.L), s.R !== F && o.push(s.R), s.low <= r && s.high >= n)) {
          let a = s.list;
          for (; a !== null; )
            a.high >= n && i(a.index, s.low), a = a.next;
        }
      }
    },
    get size() {
      return e.size;
    }
  };
}
const Ie = (e) => {
  const t = _.useRef(e);
  return _.useEffect(() => {
    t.current = e;
  }), t;
}, ro = (e, t = 100, n = !1) => {
  const r = Ie(e), i = _.useRef(), o = [t, n, r];
  function s() {
    i.current && clearTimeout(i.current), i.current = void 0;
  }
  _.useEffect(() => s, o);
  function a() {
    i.current = void 0;
  }
  return _.useCallback(function() {
    const c = arguments, {
      current: u
    } = i;
    if (u === void 0 && n)
      return i.current = setTimeout(a, t), r.current.apply(null, c);
    u && clearTimeout(u), i.current = setTimeout(() => {
      i.current = void 0, r.current.apply(null, c);
    }, t);
  }, o);
}, oo = (e, t, n) => {
  const r = _.useState(e);
  return [r[0], ro(r[1], t, n)];
};
function He(e, t, n, r) {
  const i = _.useRef(n), o = _.useRef(r);
  _.useEffect(() => {
    i.current = n, o.current = r;
  }), _.useEffect(() => {
    const s = e && "current" in e ? e.current : e;
    if (!s) return;
    let a = 0;
    function c(...d) {
      a || i.current.apply(this, d);
    }
    s.addEventListener(t, c);
    const u = o.current;
    return () => {
      a = 1, s.removeEventListener(t, c), u && u();
    };
  }, [e, t]);
}
const io = {}, ze = typeof window > "u" ? null : window, so = ze && typeof ze.visualViewport < "u" ? ze.visualViewport : null, Mt = () => [document.documentElement.clientWidth, document.documentElement.clientHeight], ao = function(e) {
  e === void 0 && (e = io);
  const {
    wait: t,
    leading: n,
    initialWidth: r = 0,
    initialHeight: i = 0
  } = e, [o, s] = oo(
    /* istanbul ignore next */
    typeof document > "u" ? [r, i] : Mt,
    t,
    n
  ), a = () => s(Mt);
  return He(ze, "resize", a), He(so, "resize", a), He(ze, "orientationchange", a), o;
}, qe = (e, t) => {
  const n = t || lo;
  let r, i;
  return function() {
    return r && n(arguments, r) ? i : i = e.apply(null, r = arguments);
  };
}, lo = (e, t) => e[0] === t[0] && e[1] === t[1] && e[2] === t[2] && e[3] === t[3];
class Rt {
  constructor() {
    this.set = void 0, this.get = void 0;
    let t, n;
    this.get = (r) => r === t ? n : void 0, this.set = (r, i) => {
      t = r, n = i;
    };
  }
}
const Xe = (e) => {
  try {
    return new e();
  } catch {
    const n = {};
    return {
      set(r, i) {
        n[r] = i;
      },
      get(r) {
        return n[r];
      }
    };
  }
}, co = (e) => {
  const t = e.length, n = Xe(e[0]);
  let r, i, o, s;
  const a = t === 1, c = (f) => (r = n.get(f[0])) === void 0 || a ? r : r.get(f[1]), u = (f, b) => (a ? n.set(f[0], b) : (r = n.get(f[0])) === void 0 ? (i = Xe(e[1]), i.set(f[1], b), n.set(f[0], i)) : r.set(f[1], b), b), d = (f) => {
    for (s = n, o = 0; o < t; o++) if ((s = s.get(f[o])) === void 0) return;
    return s;
  }, g = (f, b) => {
    for (s = n, o = 0; o < t - 1; o++)
      (i = s.get(f[o])) === void 0 && (i = Xe(e[o + 1]), s.set(f[o], i)), s = i;
    return s.set(f[t - 1], b), b;
  };
  return t < 3 ? {
    g: c,
    s: u
  } : {
    g: d,
    s: g
  };
}, gn = (e, t) => {
  let n;
  const {
    g: r,
    s: i
  } = co(e);
  return function() {
    return (n = r(arguments)) === void 0 ? i(arguments, t.apply(null, arguments)) : n;
  };
}, ot = /* @__PURE__ */ new WeakMap();
function mn() {
  const e = _.useState(uo)[1];
  return _.useRef(() => e({})).current;
}
const uo = {}, We = _.createElement;
function fo(e) {
  let {
    // Measurement and layout
    positioner: t,
    resizeObserver: n,
    // Grid items
    items: r,
    // Container props
    as: i = "div",
    id: o,
    className: s,
    style: a,
    role: c = "grid",
    tabIndex: u = 0,
    containerRef: d,
    // Item props
    itemAs: g = "div",
    itemStyle: f,
    itemHeightEstimate: b = 300,
    itemKey: R = bo,
    // Rendering props
    overscanBy: y = 2,
    scrollTop: h,
    isScrolling: w,
    height: k,
    render: N,
    onRender: T
  } = e, I = 0, $;
  const W = mn(), Z = ho(t, n), J = r.length, {
    columnWidth: v,
    columnCount: A,
    range: m,
    estimateHeight: x,
    size: p,
    shortestColumn: M
  } = t, C = p(), L = M(), P = [], z = c === "list" ? "listitem" : c === "grid" ? "gridcell" : void 0, j = Ie(T);
  y = k * y;
  const V = h + y, D = L < V && C < J;
  if (m(
    // We overscan in both directions because users scroll both ways,
    // though one must admit scrolling down is more common and thus
    // we only overscan by half the downward overscan amount
    Math.max(0, h - y / 2),
    V,
    (U, X, le) => {
      const E = r[U], q = R(E, U), ee = {
        top: le,
        left: X,
        width: v,
        writingMode: "horizontal-tb",
        position: "absolute"
      };
      typeof process < "u" && process.env.NODE_ENV !== "production" && Lt(E, U), P.push(/* @__PURE__ */ We(g, {
        key: q,
        ref: Z(U),
        role: z,
        style: typeof f == "object" && f !== null ? Object.assign({}, ee, f) : ee
      }, Tt(N, U, E, v))), $ === void 0 ? (I = U, $ = U) : (I = Math.min(I, U), $ = Math.max($, U));
    }
  ), D) {
    const U = Math.min(J - C, Math.ceil((h + y - L) / b * A));
    let X = C;
    const le = po(v);
    for (; X < C + U; X++) {
      const E = r[X], q = R(E, X);
      typeof process < "u" && process.env.NODE_ENV !== "production" && Lt(E, X), P.push(/* @__PURE__ */ We(g, {
        key: q,
        ref: Z(X),
        role: z,
        style: typeof f == "object" ? Object.assign({}, le, f) : le
      }, Tt(N, X, E, v)));
    }
  }
  _.useEffect(() => {
    typeof j.current == "function" && $ !== void 0 && j.current(I, $, r), Et = "1";
  }, [I, $, r, j]), _.useEffect(() => {
    D && W();
  }, [D, t]);
  const he = go(w, x(J, b));
  return /* @__PURE__ */ We(i, {
    ref: d,
    key: Et,
    id: o,
    role: c,
    className: s,
    tabIndex: u,
    style: typeof a == "object" ? mo(he, a) : he,
    children: P
  });
}
function Lt(e, t) {
  if (!e)
    throw new Error(`No data was found at index: ${t}

This usually happens when you've mutated or changed the "items" array in a way that makes it shorter than the previous "items" array. Masonic knows nothing about your underlying data and when it caches cell positions, it assumes you aren't mutating the underlying "items".

See https://codesandbox.io/s/masonic-w-react-router-example-2b5f9?file=/src/index.js for an example that gets around this limitations. For advanced implementations, see https://codesandbox.io/s/masonic-w-react-router-and-advanced-config-example-8em42?file=/src/index.js

If this was the result of your removing an item from your "items", see this issue: https://github.com/jaredLunde/masonic/issues/12`);
}
let Et = "0";
const Tt = /* @__PURE__ */ gn([Rt, {}, WeakMap, Rt], (e, t, n, r) => /* @__PURE__ */ We(e, {
  index: t,
  data: n,
  width: r
})), go = /* @__PURE__ */ qe((e, t) => ({
  position: "relative",
  width: "100%",
  maxWidth: "100%",
  height: Math.ceil(t),
  maxHeight: Math.ceil(t),
  willChange: e ? "contents" : void 0,
  pointerEvents: e ? "none" : void 0
})), bn = (e, t) => e[0] === t[0] && e[1] === t[1], mo = /* @__PURE__ */ qe(
  (e, t) => Object.assign({}, e, t),
  // @ts-expect-error
  bn
);
function bo(e, t) {
  return t;
}
const po = /* @__PURE__ */ qe((e) => ({
  width: e,
  zIndex: -1e3,
  visibility: "hidden",
  position: "absolute",
  writingMode: "horizontal-tb"
}), (e, t) => e[0] === t[0]), ho = /* @__PURE__ */ qe(
  (e, t) => (n) => (r) => {
    r !== null && (t && (t.observe(r), ot.set(r, n)), e.get(n) === void 0 && e.set(n, r.offsetHeight));
  },
  // @ts-expect-error
  bn
);
let pn = "undefined", we = typeof window !== pn ? window : {}, yo = typeof performance !== pn ? performance : Date, it = () => yo.now(), hn = "AnimationFrame", zt = "cancel" + hn, At = "request" + hn, De = we[At] && /* @__PURE__ */ we[At].bind(we), st = we[zt] && /* @__PURE__ */ we[zt].bind(we);
function vo(e) {
  return clearTimeout(e);
}
if (!De || !st) {
  let e = 0;
  De = (t) => {
    let n = it(), r = Math.max(e + 1e3 / 60, n);
    return setTimeout(() => {
      t(e = r);
    }, r - n);
  }, st = vo;
}
const xo = (e) => {
  st(e.v || -1);
}, wo = (e, t) => {
  const n = it(), r = {}, i = () => {
    it() - n >= t ? e.call(null) : r.v = De(i);
  };
  return r.v = De(i), r;
}, Co = typeof performance < "u" ? performance : Date, ko = () => Co.now();
function No(e, t = 30, n = !1) {
  const r = Ie(e), i = 1e3 / t, o = _.useRef(0), s = _.useRef(), a = () => s.current && clearTimeout(s.current), c = [t, n, r];
  function u() {
    o.current = 0, a();
  }
  return _.useEffect(() => u, c), _.useCallback(function() {
    const d = arguments, g = ko(), f = () => {
      o.current = g, a(), r.current.apply(null, d);
    }, b = o.current;
    if (n && b === 0) return f();
    if (g - b > i) {
      if (b > 0) return f();
      o.current = g;
    }
    a(), s.current = setTimeout(() => {
      f(), o.current = 0;
    }, i);
  }, c);
}
function So(e, t, n) {
  const r = _.useState(e);
  return [r[0], No(r[1], t, n)];
}
const Le = typeof window > "u" ? null : window, Ft = () => Le.scrollY !== void 0 ? Le.scrollY : Le.pageYOffset === void 0 ? 0 : Le.pageYOffset, Po = (e = 30) => {
  const t = So(typeof window > "u" ? 0 : Ft, e, !0);
  return He(Le, "scroll", () => t[1](Ft())), t[0];
};
function Mo(e, t) {
  e === void 0 && (e = 0), t === void 0 && (t = 12);
  const n = Po(t), [r, i] = _.useState(!1), o = _.useRef(0);
  return _.useEffect(() => {
    o.current === 1 && i(!0);
    let s = !1;
    const a = wo(() => {
      s || i(!1);
    }, 40 + 1e3 / t);
    return o.current = 1, () => {
      s = !0, xo(a);
    };
  }, [t, n]), {
    scrollTop: Math.max(0, n - e),
    isScrolling: r
  };
}
function yn(e) {
  const {
    scrollTop: t,
    isScrolling: n
  } = Mo(e.offset, e.scrollFps);
  return fo({
    scrollTop: t,
    isScrolling: n,
    positioner: e.positioner,
    resizeObserver: e.resizeObserver,
    items: e.items,
    onRender: e.onRender,
    as: e.as,
    id: e.id,
    className: e.className,
    style: e.style,
    role: e.role,
    tabIndex: e.tabIndex,
    containerRef: e.containerRef,
    itemAs: e.itemAs,
    itemStyle: e.itemStyle,
    itemHeightEstimate: e.itemHeightEstimate,
    itemKey: e.itemKey,
    overscanBy: e.overscanBy,
    height: e.height,
    render: e.render
  });
}
typeof process < "u" && process.env.NODE_ENV !== "production" && (yn.displayName = "MasonryScroller");
const Ro = at[typeof document < "u" && document.createElement !== void 0 ? "useLayoutEffect" : "useEffect"];
function Lo(e, t) {
  t === void 0 && (t = Eo);
  const [n, r] = _.useState({
    offset: 0,
    width: 0
  });
  return Ro(() => {
    const {
      current: i
    } = e;
    if (i !== null) {
      let o = 0, s = i;
      do
        o += s.offsetTop || 0, s = s.offsetParent;
      while (s);
      (o !== n.offset || i.offsetWidth !== n.width) && r({
        offset: o,
        width: i.offsetWidth
      });
    }
  }, t), n;
}
const Eo = [];
function To(e, t) {
  let {
    width: n,
    columnWidth: r = 200,
    columnGutter: i = 0,
    rowGutter: o,
    columnCount: s,
    maxColumnCount: a
  } = e;
  t === void 0 && (t = Io);
  const c = () => {
    const [R, y] = Fo(n, r, i, s, a);
    return zo(y, R, i, o ?? i);
  }, u = _.useRef();
  u.current === void 0 && (u.current = c());
  const d = _.useRef(t), g = [n, r, i, o, s, a], f = _.useRef(g), b = !g.every((R, y) => f.current[y] === R);
  if (typeof process < "u" && process.env.NODE_ENV !== "production" && t.length !== d.current.length)
    throw new Error("usePositioner(): The length of your dependencies array changed.");
  if (b || !t.every((R, y) => d.current[y] === R)) {
    const R = u.current, y = c();
    if (d.current = t, f.current = g, b) {
      const h = R.size();
      for (let w = 0; w < h; w++) {
        const k = R.get(w);
        y.set(w, k !== void 0 ? k.height : 0);
      }
    }
    u.current = y;
  }
  return u.current;
}
const zo = function(e, t, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = n);
  const i = no(), o = new Array(e), s = [], a = new Array(e);
  for (let c = 0; c < e; c++)
    o[c] = 0, a[c] = [];
  return {
    columnCount: e,
    columnWidth: t,
    set: function(c, u) {
      u === void 0 && (u = 0);
      let d = 0;
      for (let f = 1; f < o.length; f++)
        o[f] < o[d] && (d = f);
      const g = o[d] || 0;
      o[d] = g + u + r, a[d].push(c), s[c] = {
        left: d * (t + n),
        top: g,
        height: u,
        column: d
      }, i.insert(g, g + u, c);
    },
    get: (c) => s[c],
    // This only updates items in the specific columns that have changed, on and after the
    // specific items that have changed
    update: (c) => {
      const u = new Array(e);
      let d = 0, g = 0;
      for (; d < c.length - 1; d++) {
        const f = c[d], b = s[f];
        b.height = c[++d], i.remove(f), i.insert(b.top, b.top + b.height, f), u[b.column] = u[b.column] === void 0 ? f : Math.min(f, u[b.column]);
      }
      for (d = 0; d < u.length; d++) {
        if (u[d] === void 0) continue;
        const f = a[d], b = Ao(f, u[d]), R = a[d][b], y = s[R];
        for (o[d] = y.top + y.height + r, g = b + 1; g < f.length; g++) {
          const h = f[g], w = s[h];
          w.top = o[d], o[d] = w.top + w.height + r, i.remove(h), i.insert(w.top, w.top + w.height, h);
        }
      }
    },
    // Render all cells visible within the viewport range defined.
    range: (c, u, d) => i.search(c, u, (g, f) => d(g, s[g].left, f)),
    estimateHeight: (c, u) => {
      const d = Math.max(0, Math.max.apply(null, o));
      return c === i.size ? d : d + Math.ceil((c - i.size) / e) * u;
    },
    shortestColumn: () => o.length > 1 ? Math.min.apply(null, o) : o[0] || 0,
    size() {
      return i.size;
    },
    all() {
      return s;
    }
  };
}, Ao = (e, t) => {
  let n = 0, r = e.length - 1;
  for (; n <= r; ) {
    const i = n + r >>> 1, o = e[i];
    if (o === t) return i;
    o <= t ? n = i + 1 : r = i - 1;
  }
  return -1;
}, Fo = function(e, t, n, r, i) {
  return e === void 0 && (e = 0), t === void 0 && (t = 0), n === void 0 && (n = 8), r = r || Math.min(Math.floor((e + n) / (t + n)), i || 1 / 0) || 1, [Math.floor((e - n * (r - 1)) / r), r];
}, Io = [];
var It = function(t) {
  var n = [], r = null, i = function() {
    for (var s = arguments.length, a = new Array(s), c = 0; c < s; c++)
      a[c] = arguments[c];
    n = a, !r && (r = requestAnimationFrame(function() {
      r = null, t.apply(void 0, n);
    }));
  };
  return i.cancel = function() {
    r && (cancelAnimationFrame(r), r = null);
  }, i;
};
function $o(e) {
  const t = mn(), n = _o(e, t);
  function r() {
    return n.disconnect();
  }
  return _.useEffect(() => r, [n]), n;
}
function jo(e) {
  e.cancel();
}
const _o = /* @__PURE__ */ gn(
  [WeakMap],
  // TODO: figure out a way to test this
  /* istanbul ignore next */
  (e, t) => {
    const n = [], r = It(() => {
      n.length > 0 && (e.update(n), t(n)), n.length = 0;
    }), i = (u) => {
      const d = u.offsetHeight;
      if (d > 0) {
        const g = ot.get(u);
        if (g !== void 0) {
          const f = e.get(g);
          f !== void 0 && d !== f.height && n.push(g, d);
        }
      }
      r();
    }, o = /* @__PURE__ */ new Map(), s = (u) => {
      let d = 0;
      for (; d < u.length; d++) {
        const g = u[d], f = ot.get(g.target);
        if (f === void 0) continue;
        let b = o.get(f);
        b || (b = It(i), o.set(f, b)), b(g.target);
      }
    }, a = new ResizeObserver(s), c = a.disconnect.bind(a);
    return a.disconnect = () => {
      c(), o.forEach(jo);
    }, a;
  }
);
function Oo(e, t) {
  t === void 0 && (t = Go);
  const {
    isItemLoaded: n,
    minimumBatchSize: r = 16,
    threshold: i = 16,
    totalItems: o = 9e9
  } = t, s = Ie(e), a = Ie(n);
  return _.useCallback((c, u, d) => {
    const g = Bo(a.current, r, d, o, Math.max(0, c - i), Math.min(o - 1, (u || 0) + i));
    for (let f = 0; f < g.length - 1; ++f) s.current(g[f], g[++f], d);
  }, [o, r, i, s, a]);
}
function Bo(e, t, n, r, i, o) {
  e === void 0 && (e = Vo), t === void 0 && (t = 16), r === void 0 && (r = 9e9);
  const s = [];
  let a, c, u = i;
  for (; u <= o; u++)
    e(u, n) ? a !== void 0 && c !== void 0 && (s.push(a, c), a = c = void 0) : (c = u, a === void 0 && (a = u));
  if (a !== void 0 && c !== void 0) {
    const d = Math.min(Math.max(c, a + t - 1), r - 1);
    for (u = c + 1; u <= d && !e(u, n); u++)
      c = u;
    s.push(a, c);
  }
  if (s.length) {
    let d = s[0];
    const g = s[1];
    for (; g - d + 1 < t && d > 0; ) {
      const f = d - 1;
      if (!e(f, n))
        s[0] = d = f;
      else
        break;
    }
  }
  return s;
}
const Vo = (e, t) => t[e] !== void 0, Go = {};
function Ui({
  items: e,
  onFetchMore: t,
  limit: n,
  component: r,
  itemKey: i
}) {
  const o = Oo(
    () => {
      if (t && e.nextCursor !== null)
        return t(e.nextCursor, n);
    },
    {
      threshold: n,
      isItemLoaded: (s, a) => !!a[s]
    }
  );
  return /* @__PURE__ */ l(
    Ho,
    {
      onRender: t ? o : void 0,
      items: e.data,
      itemKey: i,
      maxColumnCount: 5,
      rowGutter: 6,
      columnGutter: 6,
      overscanBy: 2,
      render: r
    }
  );
}
function Ho(e) {
  var d;
  const t = se(null), [n, r] = ao(), { offset: i, width: o } = Lo(t, [
    n,
    r
  ]), s = rn("sm"), a = se(0), c = To(
    {
      width: o || (s ? n - 24 : n - 295),
      columnWidth: e.columnWidth,
      columnGutter: e.columnGutter,
      rowGutter: e.rowGutter,
      columnCount: e.columnCount,
      maxColumnCount: e.maxColumnCount
    },
    [a.current > e.items.length, (d = e.items[0]) == null ? void 0 : d._id]
  ), u = $o(c);
  return a.current = e.items.length, /* @__PURE__ */ l(
    yn,
    {
      positioner: c,
      resizeObserver: u,
      containerRef: t,
      items: e.items,
      onRender: e.onRender,
      itemKey: e.itemKey,
      height: r,
      offset: i,
      overscanBy: e.overscanBy,
      render: e.render
    }
  );
}
function qi() {
  const e = rn("md");
  return /* @__PURE__ */ l("div", { className: "flex flex-wrap gap-2", children: Array(20).fill(0).map((t, n) => /* @__PURE__ */ l(
    "div",
    {
      className: "bg-grey-2 rounded-2",
      style: {
        width: `calc(100% / ${e ? 2 : 5} - 8px)`,
        aspectRatio: 9 / 16
      }
    },
    n
  )) });
}
function Wo(e) {
  let { PI: t, min: n, max: r, cos: i, round: o } = Math, s = e[0] | e[1] << 8 | e[2] << 16, a = e[3] | e[4] << 8, c = (s & 63) / 63, u = (s >> 6 & 63) / 31.5 - 1, d = (s >> 12 & 63) / 31.5 - 1, g = (s >> 18 & 31) / 31, f = s >> 23, b = (a >> 3 & 63) / 63, R = (a >> 9 & 63) / 63, y = a >> 15, h = r(3, y ? f ? 5 : 7 : a & 7), w = r(3, y ? a & 7 : f ? 5 : 7), k = f ? (e[5] & 15) / 15 : 1, N = (e[5] >> 4) / 15, T = f ? 6 : 5, I = 0, $ = (L, P, z) => {
    let j = [];
    for (let V = 0; V < P; V++)
      for (let D = V ? 0 : 1; D * P < L * (P - V); D++)
        j.push(((e[T + (I >> 1)] >> ((I++ & 1) << 2) & 15) / 7.5 - 1) * z);
    return j;
  }, W = $(h, w, g), Z = $(3, 3, b * 1.25), J = $(3, 3, R * 1.25), v = f && $(5, 5, N), A = Do(e), m = o(A > 1 ? 32 : 32 * A), x = o(A > 1 ? 32 / A : 32), p = new Uint8Array(m * x * 4), M = [], C = [];
  for (let L = 0, P = 0; L < x; L++)
    for (let z = 0; z < m; z++, P += 4) {
      let j = c, V = u, D = d, he = k;
      for (let E = 0, q = r(h, f ? 5 : 3); E < q; E++)
        M[E] = i(t / m * (z + 0.5) * E);
      for (let E = 0, q = r(w, f ? 5 : 3); E < q; E++)
        C[E] = i(t / x * (L + 0.5) * E);
      for (let E = 0, q = 0; E < w; E++)
        for (let ee = E ? 0 : 1, Ne = C[E] * 2; ee * w < h * (w - E); ee++, q++)
          j += W[q] * M[ee] * Ne;
      for (let E = 0, q = 0; E < 3; E++)
        for (let ee = E ? 0 : 1, Ne = C[E] * 2; ee < 3 - E; ee++, q++) {
          let pt = M[ee] * Ne;
          V += Z[q] * pt, D += J[q] * pt;
        }
      if (f)
        for (let E = 0, q = 0; E < 5; E++)
          for (let ee = E ? 0 : 1, Ne = C[E] * 2; ee < 5 - E; ee++, q++)
            he += v[q] * M[ee] * Ne;
      let U = j - 2 / 3 * V, X = (3 * j - U + D) / 2, le = X - D;
      p[P] = r(0, 255 * n(1, X)), p[P + 1] = r(0, 255 * n(1, le)), p[P + 2] = r(0, 255 * n(1, U)), p[P + 3] = r(0, 255 * n(1, he));
    }
  return { w: m, h: x, rgba: p };
}
function Do(e) {
  let t = e[3], n = e[2] & 128, r = e[4] & 128, i = r ? n ? 5 : 7 : t & 7, o = r ? t & 7 : n ? 5 : 7;
  return i / o;
}
function Uo(e, t, n) {
  let r = e * 4 + 1, i = 6 + t * (5 + r), o = [
    137,
    80,
    78,
    71,
    13,
    10,
    26,
    10,
    0,
    0,
    0,
    13,
    73,
    72,
    68,
    82,
    0,
    0,
    e >> 8,
    e & 255,
    0,
    0,
    t >> 8,
    t & 255,
    8,
    6,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    i >>> 24,
    i >> 16 & 255,
    i >> 8 & 255,
    i & 255,
    73,
    68,
    65,
    84,
    120,
    1
  ], s = [
    0,
    498536548,
    997073096,
    651767980,
    1994146192,
    1802195444,
    1303535960,
    1342533948,
    -306674912,
    -267414716,
    -690576408,
    -882789492,
    -1687895376,
    -2032938284,
    -1609899400,
    -1111625188
  ], a = 1, c = 0;
  for (let u = 0, d = 0, g = r - 1; u < t; u++, g += r - 1)
    for (o.push(u + 1 < t ? 0 : 1, r & 255, r >> 8, ~r & 255, r >> 8 ^ 255, 0), c = (c + a) % 65521; d < g; d++) {
      let f = n[d] & 255;
      o.push(f), a = (a + f) % 65521, c = (c + a) % 65521;
    }
  o.push(
    c >> 8,
    c & 255,
    a >> 8,
    a & 255,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    73,
    69,
    78,
    68,
    174,
    66,
    96,
    130
  );
  for (let [u, d] of [[12, 29], [37, 41 + i]]) {
    let g = -1;
    for (let f = u; f < d; f++)
      g ^= o[f], g = g >>> 4 ^ s[g & 15], g = g >>> 4 ^ s[g & 15];
    g = ~g, o[d++] = g >>> 24, o[d++] = g >> 16 & 255, o[d++] = g >> 8 & 255, o[d++] = g & 255;
  }
  return "data:image/png;base64," + btoa(String.fromCharCode(...o));
}
function qo(e) {
  let t = Wo(e);
  return Uo(t.w, t.h, t.rgba);
}
function Ki({ thumbHash: e, ...t }) {
  const n = se(null), [r, i] = Q(!1), [o, s] = Q(!1);
  Kt(() => {
    var c;
    i(((c = n.current) == null ? void 0 : c.complete) ?? !1);
  }, []);
  const a = me(() => {
    if (!e)
      return;
    const c = atob(e).split("").map((u) => u.charCodeAt(0));
    return qo(c);
  }, [e]);
  return /* @__PURE__ */ O(pe, { children: [
    (o || !t.src) && /* @__PURE__ */ l(
      "div",
      {
        className: B(
          "flex items-center justify-center bg-grey-5",
          t.className
        ),
        children: /* @__PURE__ */ l(ie, { icon: "upload_error", className: "size-14 bg-grey-8" })
      }
    ),
    a && /* @__PURE__ */ l(
      "img",
      {
        ...t,
        src: a,
        className: B(
          t.className,
          r ? "invisible w-0 h-0" : "visible"
        )
      }
    ),
    /* @__PURE__ */ l(
      "img",
      {
        ...t,
        ref: n,
        loading: "lazy",
        onLoadCapture: () => i(!0),
        onError: () => s(!0),
        className: B(
          t.className,
          r ? "visible" : "invisible w-0 h-0"
        )
      }
    )
  ] });
}
const Ko = re({
  base: "group relative flex items-center gap-8 cursor-default select-none py-1.5 px-2.5 rounded-md will-change-transform text-sm forced-color-adjust-none",
  variants: {
    isSelected: {
      false: "text-slate-700 dark:text-zinc-300 hover:bg-slate-200 dark:hover:bg-zinc-700 -outline-offset-2",
      true: "bg-blue-600 text-white forced-colors:bg-[Highlight] forced-colors:text-[HighlightText] [&:has(+[data-selected])]:rounded-b-none [&+[data-selected]]:rounded-t-none -outline-offset-4 outline-white dark:outline-white forced-colors:outline-[HighlightText]"
    },
    isDisabled: {
      true: "text-slate-300 dark:text-zinc-600 forced-colors:text-[GrayText]"
    }
  }
});
function Zi({
  children: e,
  ...t
}) {
  return /* @__PURE__ */ l(
    Vt,
    {
      ...t,
      className: ke(t.className, "outline-0 "),
      children: e
    }
  );
}
function Xi(e) {
  const t = e.textValue ?? (typeof e.children == "string" ? e.children : void 0);
  return /* @__PURE__ */ l(Gt, { ...e, textValue: t, className: Ko, children: ae(e.children, (n) => /* @__PURE__ */ l(pe, { children: n })) });
}
function Zo(e) {
  const t = e.textValue ?? (typeof e.children == "string" ? e.children : void 0);
  return /* @__PURE__ */ l(
    Gt,
    {
      ...e,
      textValue: t,
      className: ft + " h-12 w-full",
      children: ae(e.children, (n, { isSelected: r }) => /* @__PURE__ */ O(pe, { children: [
        /* @__PURE__ */ l("span", { className: "flex items-center flex-1 gap-2 truncate", children: n }),
        /* @__PURE__ */ l("span", { className: "flex items-center w-5", children: r && /* @__PURE__ */ l(ie, { icon: "check", className: "size-4" }) })
      ] }))
    }
  );
}
function Xo(e) {
  return /* @__PURE__ */ O(Tn, { children: [
    /* @__PURE__ */ l(zn, { children: e.title }),
    /* @__PURE__ */ l(An, { items: e.items, children: e.children })
  ] });
}
const Yo = (e) => /* @__PURE__ */ l(Fn, { ...e, className: B("outline-none", e.className) });
Yo.displayName = "Menu";
const Jo = je(
  ({ size: e = "base", leftIcon: t, iconClassName: n, ...r }, i) => /* @__PURE__ */ l(
    In,
    {
      ...r,
      ref: i,
      className: ae(
        r.className,
        (o, s) => Or({ ...s, className: o, size: e })
      ),
      children: ae(r.children, (o) => /* @__PURE__ */ O(pe, { children: [
        t && /* @__PURE__ */ l(
          ie,
          {
            icon: t,
            className: B("size-5 mr-3", n)
          }
        ),
        o
      ] }))
    }
  )
);
Jo.displayName = "MenuItem";
const vn = lt({ currentAnimation: "unmounted", onComplete: void 0 }), Qo = re({
  base: "bg-white shadow-y-plus-3 rounded-4 p-2 outline-none"
}), ei = ne(Ht);
function Yi({
  placement: e = "bottom",
  ...t
}) {
  const { currentAnimation: n, onComplete: r } = ct(vn), i = me(() => {
    if (!(typeof window > "u"))
      return document.getElementById("storybook-root") ?? document.body;
  }, []);
  return /* @__PURE__ */ l(
    ei,
    {
      className: Qo(),
      UNSTABLE_portalContainer: i,
      variants: {
        hidden(o) {
          let s = 0;
          o.includes("left") ? s = -30 : o.includes("right") && (s = 30);
          let a = 0;
          return o.includes("top") ? a = 30 : o.includes("bottom") && (a = -30), {
            opacity: 0,
            scale: 0.95,
            x: s,
            y: a,
            pointerEvents: "none"
          };
        },
        visible: {
          opacity: 1,
          scale: 1,
          y: 0,
          x: 0,
          pointerEvents: "none",
          transitionEnd: {
            pointerEvents: "auto"
          }
        }
      },
      initial: "hidden",
      custom: e,
      placement: e,
      animate: n,
      transition: { type: "spring", mass: 0.2, stiffness: 150 },
      isExiting: n === "hidden",
      onAnimationComplete: r,
      ...t
    }
  );
}
function Ji(e) {
  const [t, n] = Q("unmounted"), r = (i) => {
    n(
      (o) => i === "hidden" && o === "hidden" ? "unmounted" : o
    );
  };
  return /* @__PURE__ */ l(
    vn.Provider,
    {
      value: {
        currentAnimation: t,
        onComplete: r
      },
      children: /* @__PURE__ */ l(
        $n,
        {
          ...e,
          onOpenChange: (i) => {
            var o;
            n(i ? "visible" : "hidden"), (o = e.onOpenChange) == null || o.call(e, i);
          }
        }
      )
    }
  );
}
const ti = re({
  base: "text-grey-3 bg-grey-3",
  variants: {
    orientation: {
      horizontal: "h-px w-full",
      vertical: "w-px"
    }
  },
  defaultVariants: {
    orientation: "horizontal"
  }
});
function Qi(e) {
  return /* @__PURE__ */ l(
    jn,
    {
      ...e,
      className: ti({
        orientation: e.orientation,
        className: e.className
      })
    }
  );
}
const xn = lt({
  animation: "unmounted",
  onComplete: void 0,
  isOpen: void 0
});
function es() {
  const [e, t] = Q(), n = () => t(void 0);
  return { close: n, dialogProps: {
    layoutId: e,
    close: n
  }, setLayoutId: t, layoutId: e };
}
const ni = ne(Wt), ri = ne(Dt);
function ts({
  containerClassName: e,
  className: t,
  layoutId: n,
  transition: r,
  ...i
}) {
  const { onComplete: o, animation: s, isOpen: a } = ct(xn), c = me(() => {
    if (!(typeof window > "u"))
      return document.getElementById("storybook-root") ?? document.body;
  }, []);
  return /* @__PURE__ */ l(
    ri,
    {
      className: `fixed top-0 left-0 w-screen h-screen isolate bg-black-0/50 backdrop-blur-md flex items-center justify-center z-[1000000] ${a === !1 ? "pointer-events-none" : ""}`,
      onAnimationComplete: o,
      UNSTABLE_portalContainer: c,
      isDismissable: !0,
      variants: {
        hidden: { opacity: 0 },
        visible: { opacity: 1 }
      },
      initial: "hidden",
      animate: s,
      children: /* @__PURE__ */ l(
        ni,
        {
          variants: {
            hidden: { opacity: 0, y: 50 },
            visible: { opacity: 1, y: 0 }
          },
          layoutId: n,
          transition: r,
          className: B("bg-white rounded-4 shadow-y-plus-5", e),
          children: /* @__PURE__ */ l(Ut, { className: B("outline-none", t), ...i })
        }
      )
    }
  );
}
const oi = ne(Dt), ii = ne(Wt), si = ne(Ut), ai = {
  enter: (e) => ({
    x: e > 0 ? 1e3 : -1e3,
    opacity: 0
  }),
  center: {
    x: 0,
    opacity: 1
  },
  exit: (e) => ({
    x: e < 0 ? 1e3 : -1e3,
    opacity: 0
  })
};
function ns({
  layoutId: e,
  close: t,
  containerClassName: n,
  dialogClassName: r,
  direction: i,
  onAnimationStart: o,
  onAnimationComplete: s,
  ...a
}) {
  return e ? /* @__PURE__ */ l(
    oi,
    {
      isOpen: !0,
      onOpenChange: t,
      className: "fixed top-0 left-0 w-screen h-screen isolate z-20 bg-black-0/30 flex items-center justify-center backdrop-blur-sm",
      animate: { opacity: 1 },
      initial: { opacity: 0 },
      exit: { opacity: 0 },
      isDismissable: !0,
      children: /* @__PURE__ */ l(Jn, { initial: !1, custom: i, children: /* @__PURE__ */ l(
        ii,
        {
          custom: i,
          variants: ai,
          initial: "enter",
          animate: "center",
          exit: "exit",
          layoutId: `background-${e}`,
          onAnimationStart: o,
          onAnimationComplete: s,
          className: B(
            "bg-white rounded-6 shadow-y-plus-5 absolute",
            n
          ),
          children: /* @__PURE__ */ l(
            si,
            {
              className: B("outline-none h-full", r),
              ...a
            }
          )
        },
        e
      ) })
    }
  ) : null;
}
function rs(e) {
  return /* @__PURE__ */ l(qt, { ...e });
}
function os(e) {
  const [t, n] = Q("unmounted");
  function r(o) {
    n(
      (s) => o === "hidden" && s === "hidden" ? "unmounted" : s
    );
  }
  Ae(() => {
    e.isOpen !== void 0 && i(e.isOpen);
  }, [e.isOpen]);
  function i(o) {
    var s;
    n(o ? "visible" : "hidden"), (s = e.onOpenChange) == null || s.call(e, o);
  }
  return /* @__PURE__ */ l(
    xn.Provider,
    {
      value: {
        animation: t,
        onComplete: r,
        isOpen: e.isOpen
      },
      children: /* @__PURE__ */ l(qt, { ...e, onOpenChange: i })
    }
  );
}
const li = re({
  base: "flex items-center bg-white hover:bg-grey-2 gap-2 font-medium text-black text-md rounded-4 transition-colors h-16 w-58 px-6",
  variants: {
    size: {
      md: "h-16",
      sm: "h-12"
    },
    isActive: {
      true: "font-semibold bg-grey-2"
    }
  }
});
function is({
  leftIcon: e,
  rightIcon: t,
  children: n,
  size: r = "md",
  ...i
}) {
  return /* @__PURE__ */ l("li", { children: /* @__PURE__ */ O(
    dt,
    {
      ...i,
      className: (o) => li({ ...o, size: r }),
      children: [
        e && /* @__PURE__ */ l(ie, { icon: e, className: "size-5", size: "sm" }),
        n,
        t && /* @__PURE__ */ l(ie, { icon: t, className: "size-5", size: "sm" })
      ]
    }
  ) });
}
function ss({ progress: e = 0 }) {
  return /* @__PURE__ */ l("div", { className: "w-full h-[6px] bg-white/20 rounded-4 mt-2", children: /* @__PURE__ */ l(
    ne.div,
    {
      initial: { backgroundPosition: "0 0", width: "0%" },
      animate: {
        backgroundPositionX: ["0px", "600px"],
        width: `${e}%`
      },
      transition: {
        width: { type: "tween" },
        backgroundPositionX: {
          duration: 6,
          ease: "linear",
          repeat: 1 / 0,
          repeatType: "loop"
        }
      },
      style: {
        backgroundImage: "linear-gradient(to right, #FF8762, #FFCC63, #FF7CBB, #FFCC63, #FF8762)",
        backgroundSize: "600px 100%"
      },
      className: "h-full bg-tangerine rounded-4"
    }
  ) });
}
const ci = re({
  base: "cursor-pointer group h-34 bg-transparent border-2 border-grey-4 flex items-center rounded-3 w-full sm:px-12 px-5",
  variants: {
    isSelected: {
      true: "bg-grey-1 border-black"
    },
    isHovered: {
      true: ""
    },
    isFocusVisible: {
      true: ""
    }
  }
});
function as({
  children: e,
  ...t
}) {
  return /* @__PURE__ */ O(
    _n,
    {
      ...t,
      className: ae(
        t.className,
        (n, r) => ci({
          ...r,
          className: n
        })
      ),
      children: [
        /* @__PURE__ */ l("div", { className: "border-4 border-grey-4 group-selected:border-black size-4 mr-5 rounded-full relative before:absolute before:top-0 before:left-0 before:w-full before:h-full before:rounded-full flex-shrink-0 before:scale-0 group-selected:before:scale-75 before:bg-black before:transition-all transition-all" }),
        e
      ]
    }
  );
}
function ls(e) {
  return /* @__PURE__ */ l(On, { ...e, className: "flex flex-col gap-4 mt-8 w-full" });
}
const wn = lt({ currentAnimation: "unmounted", onComplete: void 0 }), di = ne(Ht);
function ui({
  placement: e = "bottom",
  ...t
}) {
  const { currentAnimation: n } = ct(wn);
  return /* @__PURE__ */ l(
    di,
    {
      variants: {
        hidden(r) {
          let i = 0;
          return r.includes("top") ? i = 30 : r.includes("bottom") && (i = -30), {
            opacity: 0,
            scale: 0.95,
            y: i,
            pointerEvents: "none",
            transitionEnd: {
              pointerEvents: "none"
            }
          };
        },
        visible: {
          opacity: 1,
          scale: 1,
          y: 0,
          pointerEvents: "none",
          transitionEnd: {
            pointerEvents: "auto"
          }
        }
      },
      initial: "hidden",
      custom: e,
      placement: e,
      animate: n,
      transition: { type: "spring", mass: 0.2, stiffness: 150 },
      isExiting: n === "hidden",
      style: { zIndex: 1e8 },
      ...t
    }
  );
}
function fi(e) {
  const [t, n] = Q("hidden");
  return /* @__PURE__ */ l(wn.Provider, { value: { currentAnimation: t }, children: /* @__PURE__ */ l(
    Bn,
    {
      onOpenChange: (r) => n(r ? "visible" : "hidden"),
      ...e
    }
  ) });
}
function cs({
  label: e,
  description: t,
  errorMessage: n,
  children: r,
  items: i,
  popoverClassName: o,
  size: s = "l",
  ...a
}) {
  return /* @__PURE__ */ O(
    fi,
    {
      ...a,
      className: ke(
        a.className,
        "group flex flex-col gap-1"
      ),
      children: [
        e && /* @__PURE__ */ l(mt, { children: e }),
        /* @__PURE__ */ O($e, { className: (c) => gt({ ...c, size: s }), children: [
          /* @__PURE__ */ l(Vn, { className: "flex-1 text-left" }),
          /* @__PURE__ */ l(
            ie,
            {
              icon: "arrow_small_bottom",
              "aria-hidden": !0,
              className: B(s === "l" ? "size-4 ml-2" : "size-2 ml-1")
            }
          )
        ] }),
        t && /* @__PURE__ */ l(dn, { children: t }),
        /* @__PURE__ */ l(un, { children: n }),
        /* @__PURE__ */ l(ui, { className: "min-w-[--trigger-width]", children: /* @__PURE__ */ l(
          Vt,
          {
            items: i,
            className: B(
              "max-h-80 overflow-auto outline-none bg-white shadow-y-plus-3 rounded-4 p-2",
              o
            ),
            children: r
          }
        ) })
      ]
    }
  );
}
function ds(e) {
  return /* @__PURE__ */ l(Zo, { ...e });
}
function us(e) {
  return /* @__PURE__ */ l(Xo, { ...e });
}
function fs(e) {
  return /* @__PURE__ */ l(Gn, { className: "w-full", ...e, children: /* @__PURE__ */ l(Hn, { className: "relative h-7", children: ({ state: t }) => /* @__PURE__ */ O(pe, { children: [
    /* @__PURE__ */ l("div", { className: "absolute h-1 top-[50%] translate-y-[-50%] w-full rounded-full bg-grey-4/40" }),
    /* @__PURE__ */ l(
      "div",
      {
        className: "absolute h-1 top-[50%] translate-y-[-50%] rounded-full bg-tangerine",
        style: { width: t.getThumbPercent(0) * 100 + "%" }
      }
    ),
    /* @__PURE__ */ l(Wn, { className: "size-4 top-[50%] rounded-full border-1 border-solid border-tangerine bg-white transition dragging:bg-peach outline-none focus-visible:ring-2 ring-black" })
  ] }) }) });
}
function gs({
  rating: e = null,
  frozen: t = !1,
  onRatingChange: n,
  totalStars: r = 5
}) {
  const [i, o] = Q(0);
  function s(a) {
    return Math.max(
      1,
      Math.round(
        a.nativeEvent.offsetX / a.currentTarget.offsetWidth * r
      )
    );
  }
  return /* @__PURE__ */ l(
    "div",
    {
      className: B("flex items-center gap-1", {
        "cursor-pointer": !t,
        "pointer-events-none": t
      }),
      onClick: (a) => {
        const c = s(a);
        n == null || n(c);
      },
      onMouseMove: (a) => o(s(a)),
      onMouseLeave: () => o(0),
      children: [...Array(r)].map((a, c) => /* @__PURE__ */ l(
        "svg",
        {
          className: B("size-5 pointer-events-none", {
            "text-yellow": t ? c < Number(e) : c < i
          }),
          "aria-hidden": "true",
          xmlns: "http://www.w3.org/2000/svg",
          fill: "currentColor",
          viewBox: "0 0 22 20",
          children: /* @__PURE__ */ l("path", { d: "M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" })
        },
        c
      ))
    }
  );
}
function ms({ label: e, ...t }) {
  return /* @__PURE__ */ O(
    Dn,
    {
      className: "group flex gap-2 items-center disabled:text-grey-4",
      ...t,
      children: [
        e && /* @__PURE__ */ l(mt, { className: "m-0", children: e }),
        /* @__PURE__ */ l("div", { className: "flex h-[30px] w-[52px] shrink-0 cursor-pointer rounded-full shadow-inner bg-clip-padding border-2 border-solid border-black/30 p-[3px] box-border transition duration-200 ease-in-out bg-transparent group-pressed:bg-tangerine group-selected:bg-tangerine group-disabled:bg-grey-4 group-selected:group-pressed:bg-amber-900 outline-none group-focus-visible:ring-2 ring-black", children: /* @__PURE__ */ l("span", { className: "h-[22px] w-[22px] transform rounded-full bg-white border-2 border-black/30 group-selected:border-white shadow transition duration-200 ease-in-out translate-x-0 group-selected:translate-x-[100%]" }) })
      ]
    }
  );
}
const gi = re({
  slots: {
    base: "",
    icon: ""
  },
  variants: {
    variant: {
      default: {
        base: "text-md font-medium flex items-center bg-grey-1 h-10 rounded-2 px-6 cursor-pointer transition-colors outline-none",
        icon: "mr-2 bg-black"
      },
      fullwidth: {
        base: "relative cursor-pointer flex outline-none h-full md:min-w-64 md:flex-grow-0 flex-grow font-medium text-grey-8 text-center mr-1 items-center justify-center",
        icon: "mr-2 bg-grey-8"
      }
    }
  },
  compoundVariants: [
    {
      variant: "default",
      isHovered: !0,
      className: "bg-grey-3"
    },
    {
      variant: "default",
      isFocused: !0,
      className: "bg-grey-3"
    },
    {
      variant: "default",
      isSelected: !0,
      className: {
        base: "bg-black text-white",
        icon: "bg-white"
      }
    },
    {
      variant: "fullwidth",
      isSelected: !0,
      className: {
        base: "bg-clip-text text-transparent",
        icon: "bg-[#FF8762]"
      }
    }
  ]
});
function bs({
  children: e,
  leftIcon: t,
  variant: n = "default",
  ...r
}) {
  const { icon: i, base: o } = gi();
  return /* @__PURE__ */ l(
    Un,
    {
      ...r,
      className: ae(
        r.className,
        (s, a) => o({
          ...a,
          variant: n,
          className: s
        })
      ),
      children: (s) => /* @__PURE__ */ O(pe, { children: [
        t && /* @__PURE__ */ l(
          ie,
          {
            dynamicColor: !0,
            icon: t,
            className: i({ variant: n, ...s }),
            size: "sm"
          }
        ),
        n === "fullwidth" && s.isSelected ? /* @__PURE__ */ l(
          ne.span,
          {
            initial: { backgroundPosition: "0 0" },
            animate: { backgroundPositionX: ["0px", "600px"] },
            className: "bg-clip-text text-transparent",
            transition: {
              duration: 6,
              ease: "linear",
              repeat: 1 / 0,
              repeatType: "loop"
            },
            style: {
              backgroundImage: "linear-gradient(to right, #FF8762, #FFCC63, #FF7CBB, #FFCC63, #FF8762)",
              backgroundSize: "600px 100%"
            },
            children: e
          }
        ) : e,
        n === "fullwidth" && s.isSelected && /* @__PURE__ */ l(
          ne.span,
          {
            layoutId: "underline",
            className: "absolute bottom-0 left-0 right-0 h-1 rounded-1",
            initial: { backgroundPosition: "0 0" },
            animate: { backgroundPositionX: ["0px", "600px"] },
            transition: {
              type: "spring",
              mass: 0.2,
              backgroundPositionX: {
                duration: 3,
                ease: "linear",
                repeat: 1 / 0,
                repeatType: "loop"
              }
            },
            style: {
              backgroundImage: "linear-gradient(to right, #FF8762, #FFCC63, #FF7CBB, #FFCC63, #FF8762)",
              backgroundSize: "600px 100%"
            }
          }
        )
      ] })
    }
  );
}
function ps({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ l(
    qn,
    {
      ...t,
      className: ke(
        e,
        "flex gap-2 overflow-hidden"
      )
    }
  );
}
function hs(e) {
  return /* @__PURE__ */ l(Kn, { ...e });
}
function ys(e) {
  return /* @__PURE__ */ l(Zn, { ...e });
}
const mi = ne(Bt), bi = re({
  base: "text-black",
  defaultVariants: {
    weight: "regular",
    variant: "body-1"
  },
  variants: {
    weight: {
      medium: "font-medium",
      semibold: "font-semibold",
      regular: "font-regular"
    },
    variant: {
      "title-large-1": "text-5xl leading-15 tracking-tightest",
      "title-large-2": "text-4xl leading-14 tracking-tightest",
      "title-1": "text-3xl leading-13 tracking-normal",
      "title-2": "text-2xl leading-12 tracking-normal",
      "title-3": "text-xl leading-10 tracking-normal",
      "title-4": "text-lg leading-12 tracking-normal",
      "body-1": "text-base leading-12 tracking-normal",
      "body-2": "text-md leading-11 tracking-normal",
      "body-3": "text-sm leading-10 tracking-normal",
      "body-4": "text-xs leading-9 tracking-normal",
      "body-5": "text-2xs leading-8 tracking-normal"
    }
  }
}), Cn = je(function({ weight: t = "regular", variant: n = "body-1", className: r, ...i }, o) {
  return /* @__PURE__ */ l(
    mi,
    {
      ...i,
      ref: o,
      className: bi({ variant: n, className: r, weight: t })
    }
  );
});
Cn.displayName = "Text";
const { min: $t, max: jt } = Math, K = "current", pi = l("span", { style: { color: "transparent" }, children: "​" });
function hi(e, t, n, r) {
  var i = e.ownerDocument;
  r || (r = i.createRange());
  let o, s, a, c = i.createNodeIterator(e, NodeFilter.SHOW_TEXT, null, !1), u = {}, d = {};
  for (; o = c.nextNode(); ) s = o.nodeValue, a = s.length, !u.node && a > t && (u.node = o, u.offset = t), !d.node && a >= n && (d.node = o, d.offset = n), t -= a, n -= a;
  return u.node && r.setStart(u.node, jt(u.offset, 0)), d.node && r.setEnd(d.node, jt(d.offset, 0)), r;
}
const yi = ["direction", "padding", "paddingTop", "paddingBottom", "paddingLeft", "paddingRight", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight", "border", "borderWidth", "borderTopWidth", "borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderStyle", "borderTopStyle", "borderBottomStyle", "borderLeftStyle", "borderRightStyle", "fontSize", "fontFamily", "fontStyle", "fontVariant", "fontWeight", "fontStretch", "fontSizeAdjust", "textAlign", "textTransform", "textIndent", "letterSpacing", "wordSpacing", "lineHeight", "whiteSpace", "wordBreak", "overflowWrap", "tabSize", "MozTabSize"], Ue = (e, t) => e.getPropertyValue(t), Be = (e, t, n) => {
  e.setProperty(t, n);
}, ge = (e, t) => {
  const n = Ue(e, t);
  return n ? parseInt(n, 10) : 0;
}, kn = (e) => getComputedStyle(e), _t = (e) => typeof e == "string" && e.endsWith("%"), vi = (e) => ge(e, "padding-top") + ge(e, "padding-bottom") + ge(e, "border-top") + ge(e, "border-bottom"), xi = (e) => ge(e, "padding-left") + ge(e, "padding-right") + ge(e, "border-left") + ge(e, "border-right"), Ve = (e, t, n) => {
  const r = "pointer-events", i = e.style, o = t.style, s = Ue(i, r), a = Ue(o, r);
  Be(i, r, "none"), Be(o, r, "auto");
  const c = document.elementFromPoint(n.clientX, n.clientY);
  return Be(i, r, s), Be(o, r, a), wi(c, t) ? c : null;
}, wi = (e, t) => !!e && t !== e && t.contains(e), bt = (e, t, n) => {
  e.dispatchEvent(new MouseEvent(t, n));
}, Ge = (e, t) => {
  bt(e, t.type, t);
}, Ot = (e, t) => {
  e && bt(e, "mouseout", t);
}, ve = (e) => {
  e.stopPropagation();
}, Ci = (e, t, n, r) => {
  const i = kn(e), o = e.style, s = t.style;
  n[K] || (n[K] = Ue(i, "color")), yi.forEach((a) => {
    s[a] = i[a];
  }), o.color = s.borderColor = "transparent", o.caretColor = (r == null ? void 0 : r.caretColor) || n[K];
}, oe = (e, t, n) => (e.addEventListener(t, n), () => {
  e.removeEventListener(t, n);
}), ki = (e, t) => {
  let n, r = [null, null];
  const i = { t() {
    setTimeout(() => {
      t((() => {
        const o = i.o(), s = i.i();
        return r[0] === o && r[1] === s || (r = [o, s]), r;
      })());
    });
  }, l(o) {
    n = o;
  }, o() {
    const o = e[K];
    if (!o) return 0;
    const s = o.selectionStart;
    return n ? $t(s, o.selectionEnd - n.data.length) : s;
  }, i() {
    const o = e[K];
    if (!o) return 0;
    const s = o.selectionEnd;
    return n ? $t(s, o.selectionStart + n.data.length) : s;
  } };
  return i;
}, Ye = typeof window < "u" ? Kt : Ae, Ni = (e) => {
  const t = se();
  return t[K] || (t[K] = e());
}, Si = (e, t, n, r, i) => {
  let o = null;
  const s = new ResizeObserver(([N]) => {
    const { contentRect: { width: T, height: I }, borderBoxSize: $ } = N;
    if ($ && $[0]) return void r([T, I, $[0].inlineSize - T, $[0].blockSize - I]);
    const W = kn(e);
    r([T, I, xi(W), vi(W)]);
  }), a = oe(e, "focus", () => {
    i(!0);
  }), c = oe(e, "blur", () => {
    i(!1);
  }), u = oe(e, "scroll", () => {
    const { scrollTop: N, scrollLeft: T } = e;
    t.style.transform = `translate(${-T}px, ${-N}px)`;
  }), d = oe(e, "mousedown", (N) => {
    n.t();
    const T = oe(document, "mouseup", () => {
      n.t(), T();
    }), I = Ve(e, t, N);
    I && Ge(I, N);
  }), g = oe(e, "mouseup", (N) => {
    const T = Ve(e, t, N);
    T && Ge(T, N);
  }), f = oe(e, "mousemove", (N) => {
    const T = Ve(e, t, N);
    ((I, $, W) => {
      I && Ge(I, W), $ !== I && (Ot($, W), I && bt(I, "mouseover", W));
    })(T, o, N), o = T;
  }), b = oe(e, "mouseleave", (N) => {
    Ot(o, N), o = null;
  }), R = oe(e, "click", (N) => {
    const T = Ve(e, t, N);
    T && Ge(T, N);
  }), y = oe(e, "input", () => {
    n.t();
  }), h = oe(e, "compositionstart", (N) => {
    n.l(N);
  }), w = oe(e, "compositionupdate", (N) => {
    n.l(N);
  }), k = oe(e, "compositionend", () => {
    n.l();
  });
  return s.observe(e), () => {
    a(), c(), u(), d(), g(), f(), b(), R(), y(), h(), w(), k(), s.disconnect();
  };
}, Pi = /* @__PURE__ */ Yn(({ u: e, p: t, h: n, S: r }) => {
  const [i, o] = Q("");
  return Zt(t, () => o, []), O("div", { ref: e, "aria-hidden": !0, style: me(() => ({ width: r, transform: "translate(0px, 0px)", pointerEvents: "none", userSelect: "none", msUserSelect: "none", WebkitUserSelect: "none", boxSizing: "content-box", textSizeAdjust: "100%", WebkitTextSizeAdjust: "100%", MozTextSizeAdjust: "100%" }), [r]), onClick: ve, onMouseDown: ve, onMouseUp: ve, onMouseOver: ve, onMouseOut: ve, onMouseMove: ve, children: [me(() => n ? n(i) : i, [i, n]), pi] });
}), Mi = /* @__PURE__ */ je(({ children: e, autoHeight: t, style: n, onChange: r, onKeyDown: i, onSelectionChange: o, ...s }, a) => {
  const c = se(null), u = se(null), d = se(null), [[g, f, b, R], y] = Q([0, 0, 0, 0]), [h, w] = Q(!1), k = se(""), [[N, T], I] = Q([null, null]), $ = Ni(() => ki(c, I)), W = g + b, Z = f + R, J = !!(W + Z);
  return Zt(a, () => {
    const v = c[K], A = { get selectionStart() {
      return $.o();
    }, get selectionEnd() {
      return $.i();
    }, setRangeText(m, x, p, M) {
      v.setRangeText ? v.setRangeText(m, x, p, M) : (v.focus(), v.selectionStart = x, v.selectionEnd = p, document.execCommand("insertText", !1, m)), v.dispatchEvent(new Event("input", { bubbles: !0 }));
    } };
    return new Proxy(v, { get(m, x) {
      if (A[x]) return A[x];
      const p = m[x];
      return typeof p == "function" ? p.bind(m) : p;
    }, set: (m, x, p) => (m[x] = p, !0) });
  }, []), Ye(() => {
    const v = c[K], A = u[K];
    if (v && A) return Si(v, A, $, y, w);
  }, []), Ye(() => {
    const v = c[K];
    v && d[K](v.value);
  }, [s.value]), Ye(() => {
    const v = c[K], A = u[K];
    A && v && Ci(v, A, k, n);
  }, [n]), Ae(() => {
    if (N != null && T != null && o) if (h) {
      const v = hi(u[K], N, N + 1).getBoundingClientRect();
      o({ focused: !0, top: v.top, left: v.left, height: v.height, selectionStart: N, selectionEnd: T });
    } else o({ focused: !1, selectionStart: N, selectionEnd: T });
  }, [h, N, T]), Ae(() => {
    const v = c[K];
    t && v && (v.style.height = "auto", v.style.height = v.scrollHeight + "px");
  }), O("div", { style: me(() => {
    let v = W, A = Z;
    return n && (_t(n.width) && (v = n.width), _t(n.height) && (A = n.height)), { display: "inline-block", position: "relative", width: v, height: A };
  }, [W, Z, n]), children: [l("div", { style: me(() => {
    const v = { position: "absolute", overflow: "hidden", top: 0, left: 0, width: W, height: Z };
    return n && ["background", "backgroundColor"].forEach((A) => {
      n[A] && (v[A] = n[A]);
    }), v;
  }, [W, Z, n]), children: l(Pi, { u, p: d, h: e, S: g }) }), l("textarea", { ...s, ref: c, style: me(() => ({ ...n, background: "transparent", margin: 0, position: "absolute", ...!J && { position: void 0, verticalAlign: "top" } }), [n, J]), onChange: ye((v) => {
    var A;
    (A = d[K]) === null || A === void 0 || A.call(d, v.target.value), r == null || r(v);
  }, [r]), onKeyDown: ye((v) => {
    v.nativeEvent.isComposing || v.nativeEvent.keyCode === 229 || (i == null || i(v), $.t());
  }, [i]) })] });
});
function vs(e) {
  return /* @__PURE__ */ l(Mi, { ...e });
}
function xs({
  className: e,
  children: t,
  style: n
}) {
  return /* @__PURE__ */ l(
    ne.span,
    {
      className: B(
        "bg-clip-text text-transparent whitespace-nowrap",
        e
      ),
      initial: { backgroundPosition: "0 0" },
      animate: { backgroundPositionX: ["0px", "600px"] },
      transition: {
        duration: 6,
        ease: "linear",
        repeat: 1 / 0,
        repeatType: "loop"
      },
      style: {
        backgroundImage: "linear-gradient(to right, #FF8762, #FFCC63, #FF7CBB, #FFCC63, #FF8762)",
        backgroundSize: "600px 100%",
        ...n
      },
      children: t
    }
  );
}
function Ri() {
  return /* @__PURE__ */ O(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ l(
          "rect",
          {
            x: "0.792969",
            y: "0.5",
            width: "23",
            height: "23",
            rx: "11.5",
            fill: "#FF5F49"
          }
        ),
        /* @__PURE__ */ l("g", { clipPath: "url(#clip0_1135_38321)", children: /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.50733 7.21435C7.8348 6.88688 8.36574 6.88688 8.69321 7.21435L12.293 10.8141L15.8927 7.21435C16.2202 6.88688 16.7511 6.88688 17.0786 7.21435C17.4061 7.54182 17.4061 8.07276 17.0786 8.40023L13.4788 12L17.0786 15.5998C17.4061 15.9272 17.4061 16.4582 17.0786 16.7856C16.7511 17.1131 16.2202 17.1131 15.8927 16.7856L12.293 13.1859L8.6932 16.7856C8.36573 17.1131 7.83479 17.1131 7.50732 16.7856C7.17985 16.4582 7.17985 15.9272 7.50732 15.5998L11.1071 12L7.50733 8.40023C7.17986 8.07276 7.17986 7.54182 7.50733 7.21435Z",
            fill: "white"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_1135_38321", children: /* @__PURE__ */ l(
          "rect",
          {
            width: "11.5",
            height: "11.5",
            fill: "white",
            transform: "translate(6.54297 6.25)"
          }
        ) }) })
      ]
    }
  );
}
function Li() {
  return /* @__PURE__ */ O(
    "svg",
    {
      width: "24",
      height: "24",
      className: "ml-2",
      viewBox: "0 0 23 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ l("rect", { y: "0.5", width: "23", height: "23", rx: "11.5", fill: "#35BD6E" }),
        /* @__PURE__ */ l("g", { clipPath: "url(#clip0_1287_19285)", children: /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.9926 8.09283C17.3224 8.40628 17.3373 8.92942 17.0258 9.26131L10.8195 15.8738C10.6698 16.0333 10.4631 16.1264 10.2451 16.1325C10.0271 16.1386 9.81568 16.0572 9.65736 15.9063L6.00651 12.4261C5.67716 12.1121 5.6631 11.5889 5.97511 11.2575C6.28712 10.9261 6.80704 10.912 7.13638 11.2259L10.19 14.1368L15.8313 8.12622C16.1428 7.79434 16.6627 7.77939 16.9926 8.09283Z",
            fill: "white"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_1287_19285", children: /* @__PURE__ */ l(
          "rect",
          {
            width: "11.5",
            height: "11.5",
            fill: "white",
            transform: "translate(5.75 6.25)"
          }
        ) }) })
      ]
    }
  );
}
function ws(e, t = !1) {
  vt.custom((n) => /* @__PURE__ */ O(
    "div",
    {
      className: B(
        "relative overflow-hidden bg-white shadow-y-plus-4 rounded-1 w-80 h-16 flex items-center px-3 before:absolute before:top-0 before:left-0 before:h-full before:w-1",
        t ? "before:bg-red" : "before:bg-green"
      ),
      children: [
        t ? /* @__PURE__ */ l(Ri, {}) : /* @__PURE__ */ l(Li, {}),
        /* @__PURE__ */ l("div", { className: "flex-1 flex flex-col mx-4", children: /* @__PURE__ */ l(
          Cn,
          {
            variant: "body-4",
            weight: "medium",
            className: "text-grey-6 leading-5",
            children: e
          }
        ) }),
        /* @__PURE__ */ l(
          fn,
          {
            icon: "close",
            variant: "square",
            color: "transparent",
            className: "size-3",
            onPress: () => vt.dismiss(n)
          }
        )
      ]
    }
  ));
}
export {
  Oi as ActionButton,
  Bi as Badge,
  Fr as BaseUrlContext,
  Gr as Button,
  dn as Description,
  Vi as DropZone,
  Zo as DropdownItem,
  Xo as DropdownSection,
  un as FieldError,
  Gi as FieldGroup,
  St as FileTrigger,
  Hi as Form,
  xs as GradientText,
  ie as Icon,
  fn as IconButton,
  Di as ImagePicker,
  Ui as InfiniteMasonry,
  qi as InfiniteMasonrySkeleton,
  Wr as Input,
  mt as Label,
  Ki as LazyImage,
  nt as Link,
  Zi as ListBox,
  Xi as ListBoxItem,
  Yo as Menu,
  Jo as MenuItem,
  Yi as MenuPopover,
  Ji as MenuTrigger,
  xn as ModalContext,
  ts as ModalDialog,
  ns as ModalLayoutDialog,
  rs as ModalLayoutTrigger,
  os as ModalTrigger,
  is as NavElement,
  Ur as ProfileImage,
  ss as ProgressBar,
  as as Radio,
  ls as RadioGroup,
  cs as Select,
  ds as SelectItem,
  ui as SelectPopover,
  us as SelectSection,
  fi as SelectTrigger,
  Qi as Separator,
  fs as Slider,
  gs as StarRating,
  ms as Switch,
  bs as Tab,
  ps as TabList,
  hs as TabPanel,
  ys as Tabs,
  Cn as Text,
  vs as TextArea,
  Wi as TextField,
  B as cn,
  ke as composeTailwindRenderProps,
  ws as createToast,
  Ir as useBaseUrl,
  ji as useHover,
  _i as useMeasure,
  rn as useMediaQuery,
  es as useModalLayout
};
//# sourceMappingURL=design-system.js.map
